import React from "react";

import { setAmplitudeUserProperties, trackAmplitudeEvent } from "../amplitude";
import ReactDOM from "react-dom";

import moment from 'moment';
import { Chart as ChartV4, registerables as chartV4Registerables } from 'chart.js';
ChartV4.register(...chartV4Registerables);

import { collectionPctStr, collectionNameSort } from "../helpers";

import StreakSaveAppliedModalContainer from "./StreakSaves/StreakSaveAppliedModalContainer";
import StreakSaveBalanceBtn from "./StreakSaves/StreakSaveBalanceBtn";
import AddFileToCollectionModal from "./Dashboard/AddFileToCollectionModal";
import AddToCollectionModal from "./Dashboard/AddToCollectionModal";
import BlackFridayBanner from "./BlackFridayBanner";
import AddSentenceToCollectionModal from "./AddSentenceToCollectionModal";
import AddClozeFromWordsToCollectionModal from "./Dashboard/AddClozeFromWordsToCollectionModal";
import AddTextToCollectionModal from "./Dashboard/AddTextToCollectionModal";
import ClozeListeningPanel from "./Dashboard/V3ClozeListeningPanel";
import ClozeSentenceSearchModal from "./ClozeSentenceSearchModal";
import CollectionEditorModal from "./Dashboard/CollectionEditorModal";
import CollectionReviewSettingsModal from "./Dashboard/CollectionReviewSettingsModal";
import DeleteLanguagePairingModal from "./Dashboard/DeleteLanguagePairingModal";
// import CompInputs from "./CompInputs";
import Discover from "./Discover";
import DownloadAppBanner from "./DownloadAppBanner";
import DownloadFavoritesModal from "./Dashboard/DownloadFavoritesModal";
import FavoritesModal from "./Dashboard/FavoritesModal";
import FlagSprite from "./FlagSprite";
import FullHistoryBtn from "./Dashboard/FullHistoryBtn";
import Icon from "./Icon";
import LanguagePairingDropdown from "./LanguagePairingDropdown";
import LanguagePairingSettingsModal from "./Dashboard/LanguagePairingSettingsModal";
import LeaderboardPanel from "./Dashboard/V3LeaderboardPanel";
import Loading from "./Loading";
import ManageCollectionModal from "./ManageCollectionModal";
import MasteredIcon from "./MasteredIcon";
import MasteryHelpModal from "./Dashboard/MasteryHelpModal";
import Modal from "./Modal";
import ModalFooterCloseBtn from "./ModalFooterCloseBtn";
import MoreStatsModal from "./Dashboard/MoreStatsModal";
import Panel from "./Panel";
import PlayingIcon from "./PlayingIcon";
import PlayOptionsModal from "./V5PlayOptionsModal";
import QuickCaptureBtn from "./QuickCaptureBtn";
import RankingsModal from "./Dashboard/RankingsModal";
import ResetProgressModal from "./Dashboard/ResetProgressModal";
import ReviewSettingsModal from "./Dashboard/V3ReviewSettingsModal";
import ReviewPanel from "./Dashboard/V3ReviewPanel";
import SharedCollectionsModal from "./Dashboard/SharedCollectionsModal";
import StreakPanel from "./Dashboard/V3StreakPanel";
import DailyReminderModal from "./DailyReminderModal";
import Radio from "./Radio";
import trackProgressMetricSwitched from "./Dashboard/trackProgressMetricSwitched";
import V5DailyGoalPanel from "./Dashboard/V5DailyGoalPanel";
import { getPlaysGrowthDerivedStats } from "./DashboardV5/playsGrowth";
import ConfirmModal from "./TodaysPlan/ConfirmModal";
import MyCollections from "./TodaysPlan/MyCollections";
import TodaysPlan from "./TodaysPlan/TodaysPlan";

const CollectionPanelPlayedToday = ({ collection }) => {
  if(!collection.numPlaying) {
    return null;
  }

  const c = collection; // convenience

  return (
    <>
      {!!c.numPlayedToday && <span className="tw-block md:tw-inline"><Icon name="ok" style={{ color: "#27bb4e" }} /> </span>}
      <span className="tw-block md:tw-inline">Played today: {c.numPlayedToday}</span>
      {!!c.numPlayedToday && (
        <>
          <span className="tw-hidden md:tw-inline"> / </span>
          <span className="tw-block md:tw-inline">New: {c.numNewToday}</span>
          <span className="tw-hidden md:tw-inline"> / </span>
          <span className="tw-block md:tw-inline">Review: {c.numReviewedToday}</span>
        </>
      )}
    </>
  );
};

const BtnGroup = ({ active, className = "", onClick, style = {}, values }) => {
  return (
    <div className="btn-group" data-toggle="buttons">
      {values.map((v) => (
        <button
          className={`btn btn-default ${(active === v.value ? "active" : "")} ${className}`}
          key={v.value}
          style={style}
          type="button"
          value={v.value} onClick={onClick}
        >
          {v.label}
        </button>
      ))}
    </div>
  );
};

const DarkModeToggle = ({ gameSettingsUrl }) => {
  const [theme, setTheme] = React.useState(
    $("body").hasClass("dark-mode") ? "dark" : "light"
  );

  const onChange = (theme) => {
    $.ajax({
      data: {
        settings: { theme }
      },
      method: "post",
      url: gameSettingsUrl
    })
      .fail(() => {
        // TODO!
      });

    setTheme(theme);
    $("body").toggleClass("dark-mode", theme === "dark");
  };

  return (
    <div>
      <div className="tw-mb-2">Dark Mode</div>
      <BtnGroup
        active={theme}
        className="btn-xs joystix"
        onClick={(e) => onChange(e.target.value)}
        style={{ width: 44 }}
        values={[
          { label: "On", value: "dark" },
          { label: "Off", value: "light" }
        ]}
      />
    </div>
  );
};

const DailyReminderBtn = ({ dailyReminderEmail, dailyReminderEmailUrl }) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [thisDailyReminderEmail, setThisDailyReminderEmail] = React.useState(dailyReminderEmail);

  let modal = null;

  return (
    <>
      <button className={`btn btn-default daily-reminder-btn ${thisDailyReminderEmail ? "active" : ""} btn-xs tw-mr-2`} onClick={() => setModalVisible(true)}><Icon name="bell" /></button>
      {modalVisible && (
        <DailyReminderModal
          dailyReminderEmail={thisDailyReminderEmail}
          onHidden={() => setModalVisible(false)}
          onUpdate={(dailyReminderEmail) => {
            setThisDailyReminderEmail(dailyReminderEmail);
            modal.hide();
          }}
          ref={(el) => modal = el}
          updateUrl={dailyReminderEmailUrl}
        />
      )}
    </>
  );
};

export const StreakToggleBtn = ({ baseLanguageCode, languagePairingUrl, onChange, showDaysPlayedInsteadOfStreak, targetLanguageCode }) => {
  const [localShowDaysPlayedInsteadOfStreak, setLocalShowDaysPlayedInsteadOfStreak] = React.useState(showDaysPlayedInsteadOfStreak);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  const save = () => {
    setSaving(true);
    $.ajax({
      data: {
        user_language_pairing: {
          show_days_played_instead_of_streak: localShowDaysPlayedInsteadOfStreak
        }
      },
      method: "put",
      url: languagePairingUrl
    })
      .done(() => {
        setSaving(false);
        $("#streak-toggle-btn-modal").modal("hide");
        trackProgressMetricSwitched({
          baseLanguageCode,
          showsDaysPlayedAfter: localShowDaysPlayedInsteadOfStreak,
          showsDaysPlayedBefore: showDaysPlayedInsteadOfStreak,
          targetLanguageCode
        });
        onChange(localShowDaysPlayedInsteadOfStreak);
      })
      .fail(() => {
        alert("Oh no! There was an error saving the change. Sorry about that. Please try again and let us know if you see this message again.");
      });
  };

  return (
    <>
      <button className="btn btn-default btn-xs" onClick={() => setModalVisible(true)}><Icon name="cog" /></button>
      {modalVisible && (
        <Modal
          id="streak-toggle-btn-modal"
          onHidden={() => setModalVisible(false)}
          size="small"
          title="Toggle Streak"
        >
          <p>Don't care for streaks? Switch to show total days played instead.</p>
          <Radio checked={!localShowDaysPlayedInsteadOfStreak} disabled={saving} label="Streak" name="showDaysPlayedInsteadOfStreak" onChange={() => setLocalShowDaysPlayedInsteadOfStreak(false)} />
          <Radio checked={localShowDaysPlayedInsteadOfStreak} disabled={saving} label="Days Played" name="showDaysPlayedInsteadOfStreak" onChange={() => setLocalShowDaysPlayedInsteadOfStreak(true)} />
          <button className="btn btn-success btn-block joystix" disabled={saving} onClick={() => save()}>Save</button>
        </Modal>
      )}
    </>
  );
};

const LanguagePairingNotification = ({ languagePairingNotification, onPlayClick }) => {
  const {
    dismissUrl,
    collectionId,
    notification
  } = languagePairingNotification;

  // The new Fast Track is here! 10,000 sentences split into 10 collections. Try it today!

  const dismiss = () => {
    $.ajax({
      method: "post",
      url: dismissUrl
    });
  };

  return (
    <div className="alert alert-success tw-mb-5 tw-flex tw-flex-row tw-items-start tw-gap-6">
      <div className="tw-flex-1">
        <div className="tw-flex tw-items-start md:tw-items-center tw-gap-6">
          <div style={{ fontSize: 18, fontWeight: "bold" }}>🎉 {notification}</div>
          {!!collectionId && <button className="btn btn-success joystix" onClick={() => onPlayClick(collectionId)}>Play</button>}
        </div>
        <div>Or view all updates <a href="/updates">here</a>.</div>
      </div>
      <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={dismiss}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

const DropDownMenu = ({ button, lis, right = false }) => {
  return (
    <div className="dropdown">
      {button}
      <ul className={`dropdown-menu ${right && "dropdown-menu-right"}`}>
        {lis}
      </ul>
    </div>
  );
};

const toggleDashboardCollection = ({ collection, done = () => null, fail = () => alert("Error saving! Sorry about that. Please let someone know.") }) => {
  $.ajax({
    data: { user_collection: { dashboard_collection: !collection.dashboardCollection } },
    method: "put", 
    url: collection.userCollectionUrl
  })
    .done(done)
    .fail(fail);
};

const MASTERY_COLORS = {
  0: "#ff8c42",
  1: "#f0ad4e",
  2: "#ffd54f",
  3: "#aec756",
  4: "#5cb85c"
};

const CollectionProgressBars = ({ collection, onShowMasteryHelp }) => {
  const c = collection;
  const levelCounts = c.levelCounts || {};

  const totalCheckmarks = c.numSentences * 4;
  const playingPct = c.numSentences ? (c.numPlaying / c.numSentences) * 100 : 0;

  // Bucket levels >= 4 together as "mastered" (level 4), cap checkmarks at 4 per sentence
  const segmentCounts = {};
  Object.keys(levelCounts).forEach((k) => {
    const level = Math.min(Number(k), 4);
    segmentCounts[level] = (segmentCounts[level] || 0) + (levelCounts[k] || 0);
  });
  const checkmarksEarned = [0, 1, 2, 3, 4].reduce((sum, level) => sum + (segmentCounts[level] || 0) * level, 0);
  const masteryPct = totalCheckmarks > 0 ? (checkmarksEarned / totalCheckmarks) * 100 : 0;
  const segments = [];
  for(let level = 0; level <= 4; level++) {
    const count = segmentCounts[level] || 0;
    if(count > 0) {
      segments.push({ level, count, color: MASTERY_COLORS[level], percent: ((count * level) / (c.numSentences * 4)) * 100 });
    }
  }

  return (
    <div className="tw-mb-10">
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <span>
          <span className="text-secondary">Playing: </span><span className="joystix"><strong>{c.numPlaying.toLocaleString()}</strong></span><span className="text-secondary"> / {c.numSentences.toLocaleString()} sentences</span>
        </span>
        <span>{playingPct.toFixed(1)}%</span>
      </div>
      <div className="progress" style={{ height: 10, marginBottom: 4 }}>
        {segments.map((seg, i) => (
          <div key={i} data-toggle="tooltip" title={`${seg.level * 25}% Mastered: ${seg.count.toLocaleString()} sentences`} style={{ width: seg.percent + "%", height: "100%", backgroundColor: seg.color, float: "left" }}></div>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          {masteryPct.toFixed(1)}% Mastery
          {" "}
          <button
            className="btn btn-default btn-xs"
            onClick={onShowMasteryHelp}
            // style={{ padding: "0 4px", lineHeight: 1, fontSize: 11, verticalAlign: "middle" }}
          >
            <Icon name="question-sign" />
          </button>
        </span>
        <span><MasteredIcon /> {c.numMastered.toLocaleString()} Mastered</span>
      </div>
    </div>
  );
};

const ProgressRing = ({ size = 36, strokeWidth = 3, percent, color = "#5cb85c", bgColor = "#e0e0e0" }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(percent, 100) / 100) * circumference;

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)", flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={bgColor} strokeWidth={strokeWidth} />
      <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" />
    </svg>
  );
};

const PixelProgressBar = ({ percent, segments = 100 }) => {
  const filled = Math.floor((Math.min(percent, 100) / 100) * segments);
  return (
    <div className="pixel-progress-bar" style={{ display: "flex", gap: 2, flexShrink: 0 }}>
      {Array.from({ length: segments }, (_, i) => (
        <div key={i} className={i < filled ? "pixel-filled" : "pixel-empty"} />
      ))}
    </div>
  );
};

const TrophyIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 512 512" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4 }}>
    <polygon style={{ fill: "#FFDE46" }} points="411.826,77.913 411.826,0 389.565,0 378.435,0 133.565,0 100.174,0 100.174,77.913 0,77.913 0,111.304 0,211.478 33.391,211.478 33.391,244.87 66.783,244.87 66.783,278.261 100.174,278.261 100.174,311.652 133.565,311.652 133.565,345.043 166.957,345.043 166.957,378.435 200.348,378.435 200.348,411.826 133.565,411.826 133.565,445.217 100.174,445.217 100.174,478.609 100.174,478.609 100.174,512 100.174,512 133.565,512 378.435,512 411.826,512 411.826,445.217 378.435,445.217 378.435,411.826 311.652,411.826 311.652,378.435 345.043,378.435 345.043,345.043 378.435,345.043 378.435,311.652 389.565,311.652 411.826,311.652 411.826,278.261 445.217,278.261 445.217,244.87 478.609,244.87 478.609,211.478 512,211.478 512,111.304 512,77.913" />
    <g><polygon style={{ fill: "#FFFFFF" }} points="166.957,0 155.826,0 133.565,0 100.174,0 100.174,111.304 133.565,111.304 133.565,144.696 166.957,144.696 166.957,66.783 411.826,66.783 411.826,0" /><rect x="100.174" y="178.087" style={{ fill: "#FFFFFF" }} width="66.783" height="33.391" /></g>
    <rect x="133.565" y="311.652" width="33.391" height="33.391" />
    <polygon points="200.348,378.435 200.348,411.826 133.565,411.826 133.565,445.217 200.348,445.217 222.609,445.217 233.739,445.217 233.739,378.435 233.739,345.043 200.348,345.043 166.957,345.043 166.957,378.435" />
    <rect x="33.391" y="211.478" width="33.391" height="33.391" />
    <polygon points="100.174,278.261 100.174,311.652 133.565,311.652 133.565,278.261 133.565,244.87 100.174,244.87 66.783,244.87 66.783,278.261" />
    <polygon points="133.565,211.478 133.565,144.696 100.174,144.696 66.783,144.696 66.783,178.087 100.174,178.087 100.174,211.478" />
    <polygon points="378.435,478.609 133.565,478.609 133.565,445.217 100.174,445.217 100.174,478.609 100.174,478.609 100.174,512 100.174,512 100.174,512 133.565,512 133.565,512 378.435,512 378.435,512 411.826,512 411.826,445.217 378.435,445.217" />
    <rect x="345.043" y="311.652" width="33.391" height="33.391" />
    <polygon points="278.261,345.043 278.261,378.435 278.261,445.217 289.391,445.217 311.652,445.217 378.435,445.217 378.435,411.826 311.652,411.826 311.652,378.435 345.043,378.435 345.043,345.043 311.652,345.043" />
    <rect x="445.217" y="211.478" width="33.391" height="33.391" />
    <polygon points="411.826,178.087 445.217,178.087 445.217,144.696 411.826,144.696 378.435,144.696 378.435,211.478 411.826,211.478" />
    <polygon points="378.435,244.87 378.435,278.261 378.435,311.652 411.826,311.652 411.826,278.261 445.217,278.261 445.217,244.87 411.826,244.87" />
    <polygon points="478.609,77.913 411.826,77.913 411.826,0 389.565,0 378.435,0 133.565,0 100.174,0 100.174,33.391 100.174,77.913 33.391,77.913 0,77.913 0,111.304 0,211.478 33.391,211.478 33.391,111.304 100.174,111.304 133.565,111.304 133.565,77.913 133.565,33.391 378.435,33.391 378.435,77.913 378.435,111.304 411.826,111.304 478.609,111.304 478.609,211.478 512,211.478 512,111.304 512,77.913" />
  </svg>
);

const CollectionUnitProgress = ({ collectionUnits, onSelectUnit }) => {
  const [expanded, setExpanded] = React.useState(false);

  if(!collectionUnits || !collectionUnits.units || !collectionUnits.units.length) {
    return null;
  }

  const { currentUnitId, units } = collectionUnits;
  const currentUnit = units.find((u) => u.id === currentUnitId) || units[0];
  const currentUnitIndex = units.indexOf(currentUnit) + 1;

  return (
    <div className="tw-mb-10">
      <button
        className="btn btn-default btn-block"
        onClick={() => setExpanded(!expanded)}
        style={{ textAlign: "left", padding: "10px 12px" }}
        type="button"
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: "bold", whiteSpace: "normal" }}><span className="collection-unit-label" style={{ fontSize: 10, position: "relative", top: -1, marginRight: 6 }}>Unit {currentUnitIndex}</span>{currentUnit.name} <span className="collection-unit-label collection-unit-label-current" style={{ fontSize: 9, position: "relative", top: -1, marginLeft: 6 }}>CURRENT</span></div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              Played {currentUnit.numPlaying} / {currentUnit.numSentences} sentences ({currentUnit.progressPct}%){currentUnit.numPlaying === currentUnit.numSentences && currentUnit.numSentences > 0 && <TrophyIcon size={14} />}
            </div>
          </div>
          <Icon name={`chevron-${expanded ? "up" : "down"}`} />
        </div>
        <PixelProgressBar percent={currentUnit.progressPct} />
      </button>
      {expanded && (
        <div style={{ borderTop: 0, padding: "4px 0" }}>
          {units.map((unit, i) => {
            const isCurrent = unit.id === currentUnitId;
            return (
              <button
                key={unit.id}
                className="collection-unit-panel"
                onClick={() => onSelectUnit(unit)}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "10px 12px",
                  marginBottom: 4,
                  border: isCurrent ? "2px solid #5cb85c" : "1px solid #ddd",
                  borderRadius: 4,
                  background: isCurrent ? "rgba(92, 184, 92, 0.08)" : "none",
                  cursor: "pointer"
                }}
                type="button"
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: isCurrent ? "bold" : "normal" }}><span className="collection-unit-label" style={{ fontSize: 10, position: "relative", top: -1, marginRight: 6 }}>Unit {i + 1}</span>{unit.name}{isCurrent && <span className="collection-unit-label collection-unit-label-current" style={{ fontSize: 9, position: "relative", top: -1, marginLeft: 6 }}>CURRENT</span>}</div>
                    <div style={{ fontSize: 12, opacity: 0.7 }}>
                      Played {unit.numPlaying} / {unit.numSentences} sentences ({unit.progressPct}%){unit.numPlaying === unit.numSentences && unit.numSentences > 0 && <TrophyIcon size={14} />}
                    </div>
                  </div>
                  <span className="btn btn-success btn-xs joystix" style={{ pointerEvents: "none" }}>Play <Icon name="chevron-right" /></span>
                </div>
                <PixelProgressBar percent={unit.progressPct} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

const CollectionsPanelCustomCollectionsControls = ({ isPro, play, sharedCollectionsUrl, showCollectionEditor }) => {
  const [sharedCollectionsModalVisible, setSharedCollectionsModalVisible] = React.useState(false);
  const sharedCollectionsModalRef = React.useRef(null);

  return (
    <>
      <div className="tw-mt-5 tw-flex tw-flex-row tw-gap-5 tw-mb-3">
        <button className="btn btn-success-outline btn-lg joystix" onClick={showCollectionEditor}>Create</button>
        <button className="btn btn-success-outline btn-lg joystix" onClick={() => setSharedCollectionsModalVisible(true)}>Shared</button>
      </div>
      {sharedCollectionsModalVisible && (
        <SharedCollectionsModal
          isPro={isPro}
          play={(collection) => sharedCollectionsModalRef.current.hide({ onHidden: () => play({ collection }) })}
          onHidden={() => setSharedCollectionsModalVisible(false)}
          ref={sharedCollectionsModalRef}
          url={sharedCollectionsUrl}
        />
      )}
    </>
  );
};

const CollectionsPanel = ({ collections, collectionType = null, customCollectionsPanel = false, description = null, first = false, isPro, manage, name = null, nextReviewByLevel, play, requestUnpin = null, sharedCollectionsUrl, showAddToCollectionModal, showCollectionEditor, totalNumPlaying, update }) => {
  if(!collections.length && !customCollectionsPanel) {
    return null;
  }

  const [open, setOpen] = React.useState(first);
  const [togglingPin, setTogglingPin] = React.useState(false);
  const [masteryHelpCollection, setMasteryHelpCollection] = React.useState(null);

  React.useEffect(() => {
    // TODO! save localstorage
  }, [open]);

  // - description
  // - cm, machine, mine, shared, etc. icon
  // - dropdown menu
  // X pin toggle
  // X success outline if not playing
  // X first first "start here" recommendation
  // - custom collections
  // - mobile
  // X all collection types
  // X collection groupings
  // - panel ordering
  // X pro locked

  const togglePin = (collection) => {
    if(collection.dashboardCollection && requestUnpin) {
      requestUnpin(collection);
      return;
    }
    setTogglingPin(true);
    toggleDashboardCollection({
      collection,
      done: (data) => {
        setTogglingPin(false);
        update(data.collection);
      }
    });
  };

  return (
    <Panel className={open ? "open" : ""} attrs={{ "data-panel-name": name || collections[0].name, "data-type": collectionType }}>
      <div className="tw-flex tw-flex-row tw-items-start tw-justify-start tw-gap-5">
        <button className="btn btn-default toggle-open" onClick={() => setOpen(!open)}><Icon name={`chevron-${open ? "up" : "down"}`} /></button>
        <div className="md:tw-flex md:tw-flex-row md:tw-gap-5 md:tw-items-center">
          <div className="tw-text-5xl tw-font-bold">{name || collections[0].name}</div>
          <div>{collections.length > 1 && <>{collections.length} Collections / </>}{collections.reduce((n, c) => n + c.numSentences, 0).toLocaleString()} Sentences</div>
        </div>
      </div>
      {open && (
        <div className="tw-mt-5">
          {description && (
            <p>{description}</p>
          )}
          {customCollectionsPanel && (
            <CollectionsPanelCustomCollectionsControls
              isPro={isPro}
              play={play}
              sharedCollectionsUrl={sharedCollectionsUrl}
              showCollectionEditor={showCollectionEditor}
            />
          )}
          {collections.map((c, index) => (
            <div
              className={`${collections.length > 1 ? "tw-py-10" : ""} tw-border-0 ${index === 0 ? "" : "tw-border-t tw-border-solid tw-border-divider"}`}
              data-collection-name={c.name}
              data-testid="collection"
            >
              <div className="tw-flex tw-flex-row tw-mb-10">
                <div className="tw-flex-1 tw-flex tw-flex-col tw-flex-wrap md:tw-flex-row md:tw-items-center">
                  {(collections.length > 1 || customCollectionsPanel) && <div className="tw-text-4xl tw-font-bold tw-mr-5">{c.name}</div>}
                  <div className="tw-flex tw-flex-row-reverse md:tw-flex-row tw-justify-end md:tw-justify-start tw-items-center tw-gap-5 tw-mr-5 tw-flex-wrap tw-mt-2 md:tw-mt-0">
                    {/*collections.length > 1 && <div className="">{c.numSentences.toLocaleString()} Sentences</div>*/}
                    {!!c.description && (
                      <div><button className="btn btn-default btn-xs" data-content={c.description} data-html="true" data-toggle="popover" data-trigger="focus"><Icon name="info-sign" /></button></div>
                    )}
                  </div>
                </div>
                <div className="tw-flex tw-flex-row tw-gap-5 tw-items-start">
                  <button
                    className={`tw-hidden md:tw-inline-block btn btn-default btn-sm ${c.dashboardCollection ? "active" : ""}`}
                    disabled={togglingPin}
                    onClick={() => togglePin(c)}
                  >
                    <Icon name="pushpin" /> {c.dashboardCollection ? "Unpin from" : "Pin to"} Dashboard
                  </button>
                  <DropDownMenu
                    button={<button className="btn btn-default btn-sm collection-menu-toggle" data-toggle="dropdown"><Icon name="option-horizontal" /></button>}
                    lis={
                      <>
                        <li className="md:tw-hidden"><a data-target="#" role="button" onClick={() => togglePin(c)}><Icon name="pushpin" /> {c.dashboardCollection ? "Unpin from" : "Pin to"} Dashboard</a></li>
                        {c.isEditable && <li><a data-target="#" role="button" onClick={() => showAddToCollectionModal(c)}><Icon name="plus" /><span className="tw-ml-5">Add Sentences</span></a></li>}
                        <li><a data-target="#" role="button" onClick={() => manage(c)}><Icon name="list" /><span className="tw-ml-5">Manage Sentences</span></a></li>
                        {c.isEditable && <li><a data-target="#" role="button" onClick={() => showCollectionEditor(c)}><Icon name="pencil" /><span className="tw-ml-5">Edit Collection</span></a></li>}
                      </>
                    }
                    right={true}
                  />
                </div>
              </div>
              <CollectionProgressBars
                collection={c}
                onShowMasteryHelp={() => setMasteryHelpCollection(c)}
              />
              {c.collectionUnits && (
                <CollectionUnitProgress
                  collectionUnits={c.collectionUnits}
                  onSelectUnit={(unit) => play({ collection: c, collectionUnitId: unit.id })}
                />
              )}
              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-5 tw-mb-5">
                <button
                  className={`btn btn-success${true || c.dashboardCollection || (first && totalNumPlaying === 0 && index === 0) ? "" : "-outline"} btn-block tw-flex-1 joystix`}
                  disabled={(c.proOnly || !c.type) && !isPro}
                  onClick={() => play({ collection: c, collectionUnitId: c.collectionUnits?.currentUnitId || null })}
                >
                  Play <Icon name="chevron-right" />
                </button>
                {!!c.numPlaying && (
                  <div className="tw-flex tw-flex-1">
                    <button className="btn btn-success-outline btn-sm joystix tw-flex-1" disabled={!c.numReadyForReview} onClick={() => play({ collection: c, scope: "ready_for_review" })}>Review ({c.numReadyForReview})</button>
                  </div>
                )}
              </div>
              {(c.proOnly || !c.type) && !isPro && <div className="tw-text-center tw-mb-5"><a href="/pro" className="btn btn-default btn-sm joystix"><Icon name="lock" /> Pro!</a></div>}
              {first && totalNumPlaying === 0 && index === 0 && (
                <div className="tw-text-center joystix tw-mb-5">👉👉👉 Not sure where to start? Start here! 👈👈👈</div>
              )}
              <div className="tw-flex tw-flex-row tw-justify-end">
                <div className="tw-flex-1">
                  {!!c.user && (
                    <div><Icon name={c.public ? "users" : "lock"} type="fa" /> {c.public ? "Shared" : "Private"}</div>
                  )}
                  {!!c.user && !c.isEditable && (
                    <div>Created by <a href={`/players/${c.user.username}`} target="_blank">{c.user.username}</a></div>
                  )}
                  <CollectionPanelPlayedToday
                    collection={c}
                  />
                </div>
                {!!c.numMarkedAsKnown && <div>Marked as Known: {c.numMarkedAsKnown}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
      {masteryHelpCollection && (
        <MasteryHelpModal
          collection={masteryHelpCollection}
          nextReviewByLevel={nextReviewByLevel}
          onHidden={() => setMasteryHelpCollection(null)}
        />
      )}
    </Panel>
  );
};

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "dashboard",
      activeMobilePanels: 0,
      aboutToPlayCollection: null,
      aboutToPlayCollectionUnitId: null,
      aboutToPlayScope: null,
      addingToCollection: null,
      addSentenceToCollectionVisible: false,
      collectionEditorCollection: null,
      collectionEditorModalVisible: false,
      favoritesModalVisible: false,
      loading: true,
      managingCollection: null,
      managingCollectionScope: null,
      masteryHelpCollection: null,
      masteryHelpScope: null,
      moreStatsVisible: false,
      reviewModalVisible: false,
      reviewPickerVisible: false,
      dashboardCollectionSort: window.localStorage.getItem("dashboardCollectionSort") || "name",
      reviewSettingsModalVisible: false,
      rankingsModalVisible: false,
      backgroundImageEnabled: window.localStorage.getItem("dashboardV5BackgroundImageEnabled") !== "false",
      statsExpanded: window.localStorage.getItem("dashboardStatsExpandedV5") !== "false",
      streakSaveAppliedVisible: false,
      streakSaveAppliedContext: null
    };
  }

  getCollectionsStats(collections) {
    let numPlaying = 0;
    let numMastered = 0;
    let numReadyForReview = 0;
    let numFavorited = 0;

    for(let i = 0, n = collections.length; i < n; i++) {
      numPlaying += collections[i].numPlaying;
      numMastered += collections[i].numMastered;
      // if(collections[i].dashboardCollection) {
        numReadyForReview += collections[i].numReadyForReview;
      // }
      numFavorited += collections[i].numFavorited;
    }

    return {
      numFavorited,
      numMastered,
      numPlaying,
      numReadyForReview
    };
  }

  componentDidMount() {
    // Cohort assignment is durable per user, so it belongs in user properties rather
    // than on each event. Set from the dashboard specifically: experiment_variant
    // creates the participant on first call, and the dashboard is where the Translate
    // option would have been seen - putting it in the global Amplitude bootstrap would
    // enrol every visitor to every page, including anonymous ones.
    setAmplitudeUserProperties({
      experiment_translate_reviews: this.props.translateReviewsVariant || null
    });

    // Allow linking directly to a tab via ?tab=collections etc.
    // Store it as pending — applied after data loads in loadLanguagePairing.
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");
    if (tabParam && ["collections", "discover"].includes(tabParam)) {
      this._pendingTab = tabParam;
    }
    // ?play_collection=<id> opens that collection's play options once the collections
    // load - where a sign up from a CEFR landing page lands (CefrLandingClaimable).
    const playCollectionParam = urlParams.get("play_collection");
    if (playCollectionParam) {
      this._pendingPlayCollectionId = parseInt(playCollectionParam, 10);
    }
    if (this.props.todaysPlanEnabled || urlParams.get("todays_plan") === "true") {
      this.setState({ todaysPlanEnabled: true });
    }
    if (urlParams.get("extra_data") === "true") {
      this._extraDataEnabled = true;
    }

    const $dashboard = $('[data-react-class="DashboardV5"]');

    $dashboard.popover({
      selector: '[data-toggle="popover"]'
    });
    $dashboard.on('show.bs.popover', '[data-toggle="popover"]', function(e) {
      $('[data-toggle="popover"]').not(this).popover('destroy');
    });
    $dashboard.on('inserted.bs.popover', '[data-toggle="popover"]', function(e) {
      $('.popover .popover-title').append(
        '<button type="button" class="close" data-dismiss="popover" aria-label="Close" style="margin-top: -4px"><span aria-hidden="true">&times;</span></button>'
      );
    });
    $dashboard.on('click', '.popover .close', () => {
      $('[data-toggle="popover"]').popover('destroy');
    });

    $('body').tooltip({ selector: '[data-toggle="tooltip"]' });

    // run check to load voices
    window.clozemaster.systemTtsAvailable(this.props.targetLanguageIso, this.props.targetLanguageCode);

    this.updateBackgroundImageClass(this.state.backgroundImageEnabled);

    this.loadLanguagePairing();
  }

  componentWillUnmount() {
    $("body").removeClass("v5-bg-image-disabled");
  }

  // Once only: the param comes off the URL so a refresh doesn't reopen the modal.
  openPendingPlayCollection() {
    const collection = (this.state.collections || []).find((c) => c.id === this._pendingPlayCollectionId);
    this._pendingPlayCollectionId = null;

    const url = new URL(window.location.href);
    url.searchParams.delete("play_collection");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);

    if (collection) {
      this.setState({ aboutToPlayCollection: collection, aboutToPlayCollectionUnitId: collection.collectionUnits?.currentUnitId || null });
    }
  }

  updateBackgroundImageClass(enabled) {
    $("body").toggleClass("v5-bg-image-disabled", !enabled);
  }

  toggleBackgroundImage() {
    const backgroundImageEnabled = !this.state.backgroundImageEnabled;
    window.localStorage.setItem("dashboardV5BackgroundImageEnabled", backgroundImageEnabled);
    this.updateBackgroundImageClass(backgroundImageEnabled);
    this.setState({ backgroundImageEnabled });
  }

  loadLanguagePairing() {
    this.setState({ loading: true });
    this.refreshLanguagePairing();
  }

  // Reloads the data behind the dashboard without swapping it for the loading spinner.
  refreshLanguagePairing() {
    const {
      includeCefr,
      includeDiscover,
      includeFastTrackV2Collections,
      languagePairingUrl
    } = this.props;

    $.ajax({
      data: {
        include_cefr: includeCefr,
        include_discover: includeDiscover,
        include_fast_track_v2_collections: includeFastTrackV2Collections,
        extra_data: this._extraDataEnabled ? "true" : undefined
      },
      url: languagePairingUrl
    }).done((data) => {
      console.log("DATA", data);
      const { collectionGroupings, collections, languagePairing, user } = data;

      const {
        clozeFromWordsUrl,
        clozeListening,
        clozeSentencesUrl,
        collectionFileImportUrl,
        collectionsUrl,
        // compInputsUrl,
        currentLevelPoints,
        currentStreakDays,
        currentStreakIncludesToday,
        currentWeekLeaderboardRank,
        dailyGoalHoursLeftToday,
        dailyGoalPointsPerDay,
        dailyGoalStreak,
        dailyGoalUrl,
        dailyReminderEmail,
        dailyReminderEmailUrl,
        dailyStatsWebUrl,
        daysPlayedCount,
        defaultMaxReviewsPerCollectionPerDay,
        discoverMediasUrl,
        gameSettingsUrl,
        id,
        leaderboardsUrl,
        level,
        listeningTrialExpired,
        maxReviewsPerRound,
        moreStatsUrl,
        nextLevelPoints,
        nextReviewByLevel,
        notification,
        numPointsToday,
        past7DaysNewReview,
        playClozeListeningWebUrl,
        playOptions,
        playsGrowth,
        playWebUrl,
        prevWeekLeaderboardRank,
        progressPerChunk,
        quickClozeUrl,
        uccsStats,
        rankingsUrl,
        resetProgressUrl,
        reviewSettingsUrl,
        score,
        sharedCollectionsUrl,
        showDaysPlayedInsteadOfStreak,
        speakingTrialExpired,
        streakSaveBalance,
        savedDates,
        shouldCelebrateSave,
        daysSinceLastSession,
        todaysPlanSettingsUrl,
        useProgressChunks
      } = languagePairing;

      const { isSignedIn } = this.props;
      // this should only ever happen once after signing up
      if(isSignedIn && !user.hasRunPlayTutorial && !!window.localStorage.getItem("hasRunPlayTutorial")) {
        this.saveHasRunPlayTutorial();
      }

      this.setState(Object.assign(this.getCollectionsStats(collections), {
        clozeFromWordsUrl,
        clozeListening,
        clozeSentencesUrl,
        collectionFileImportUrl,
        collectionGroupings,
        collections,
        collectionsUrl,
        // compInputsUrl,
        currentLevelPoints,
        currentStreakDays,
        currentStreakIncludesToday,
        currentWeekLeaderboardRank,
        dailyGoalHoursLeftToday,
        dailyGoalPointsPerDay,
        dailyGoalStreak,
        dailyGoalUrl,
        dailyReminderEmail,
        dailyReminderEmailUrl,
        dailyStatsUrl: dailyStatsWebUrl,
        daysPlayedCount,
        defaultMaxReviewsPerCollectionPerDay,
        discoverMediasUrl,
        gameSettingsUrl,
        languagePairingId: id,
        languagePairingNotification: notification,
        leaderboardsUrl,
        level,
        listeningTrialExpired,
        loading: false,
        maxReviewsPerRound,
        moreStatsUrl,
        nextLevelPoints,
        nextReviewByLevel,
        numPointsToday,
        past7DaysNewReview,
        playClozeListeningUrl: playClozeListeningWebUrl,
        playLanguagePairingWebUrl: playWebUrl,
        playOptions,
        playsGrowth,
        prevWeekLeaderboardRank,
        progressPerChunk,
        quickClozeUrl,
        rankingsUrl,
        resetProgressUrl,
        reviewSettingsUrl,
        score,
        sharedCollectionsUrl,
        showDaysPlayedInsteadOfStreak,
        speakingTrialExpired,
        streakSaveBalance,
        savedDates,
        shouldCelebrateSave,
        todaysPlanSettingsUrl,
        uccsStats,
        useProgressChunks,
        user
      }), () => {
        this.initPast7DaysChart();
        this.initPlaysGrowthChart();
        if (this._pendingTab) {
          this.setState({ activeTab: this._pendingTab });
          this._pendingTab = null;
        }
        if (this._pendingPlayCollectionId) {
          this.openPendingPlayCollection();
        }
        if (shouldCelebrateSave) {
          this.setState({
            streakSaveAppliedVisible: true,
            streakSaveAppliedContext: {
              currentStreakDays,
              currentBalance: streakSaveBalance,
              daysSinceLastSession,
              ackUrl: languagePairing.streakSaveCelebrationsAcknowledgeUrl,
              savedDate: savedDates && savedDates.length ? savedDates[savedDates.length - 1] : null,
            },
          });
        }
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.activeTab === "dashboard" && prevState.activeTab !== "dashboard") {
      this.initPast7DaysChart();
      this.initPlaysGrowthChart();
    }

    if(this.state.activeTab !== prevState.activeTab) {
      window.scrollTo(0, 0);
    }
  }

  initPast7DaysChart() {
    if(!this.past7DaysCanvas) return;
    const { past7DaysNewReview } = this.state;
    const dates = [];
    const totalCounts = [];

    past7DaysNewReview.forEach((d) => {
      dates.push(moment(d.date, "YYYY-MM-DD").format('ddd').toUpperCase());
      totalCounts.push(d.numNew + d.numReview);
    });

    if(this.past7DaysChart) {
      this.past7DaysChart.destroy();
      this.past7DaysChart = null;
    }

    const ctx = this.past7DaysCanvas.getContext('2d');
    if(!ctx) return; // jsdom returns null in tests
    this.past7DaysChart = new ChartV4(ctx, {
      type: 'line',
      data: {
        labels: dates,
        datasets: [
          {
            label: "Played",
            backgroundColor: "rgba(92,184,91,0.2)",
            borderColor: "rgba(92,184,91,1)",
            pointBackgroundColor: "rgba(92,184,91,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(92,184,91,1)",
            tension: 0,
            fill: true,
            data: totalCounts
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (item) => `${item.parsed.y} played`
            }
          }
        },
        scales: {
          y: { beginAtZero: true }
        }
      }
    });
  }

  saveHasRunPlayTutorial() {
    $.ajax({
      contentType: "application/json",
      data: JSON.stringify({
        user: { has_run_play_tutorial: true }
      }),
      method: "put",
      url: "/api/v1/users"
    });
  }

  openFavoritesModal(action) {
    this.setState({ favoritesModalVisible: action });
  }

  renderDownloadFavoritesModal() {
    const { downloadFavoritesCollection, user } = this.state;

    if(!downloadFavoritesCollection) {
      return null;
    }

    return (
      <DownloadFavoritesModal
        collection={downloadFavoritesCollection}
        isPro={user.isPro}
        onHidden={() => this.setState({ downloadFavoritesCollection: null })}
      />
    );
  }

  renderFavoritesModal() {
    const { collections, favoritesModalVisible, playLanguagePairingWebUrl, user } = this.state;

    if(!favoritesModalVisible) {
      return null;
    }

    return (
      <FavoritesModal
        action={favoritesModalVisible}
        collections={collections}
        isPro={user.isPro}
        onDownload={(collection) => this.favoritesModal.hide({
          onHidden: () => this.setState({ downloadFavoritesCollection: collection })
        })}
        onHidden={() => this.setState({ favoritesModalVisible: false })}
        onPlay={(collection) => this.favoritesModal.hide({
          onHidden: () => this.setState({ aboutToPlayCollection: collection, aboutToPlayScope: 'favorited' })
        })}
        onView={(collection) => this.favoritesModal.hide({
          onHidden: () => this.setState({ managingCollection: collection, managingCollectionScope: 'favorited' })
        })}
        playLanguagePairingUrl={playLanguagePairingWebUrl}
        ref={(e) => this.favoritesModal = e}
      />
    );
  }

  showAddToCollectionModal(collection) {
    this.setState({
      addingToCollection: collection,
      addToCollectionVisible: true
    });
  }

  showCollectionEditor(collection) {
    this.setState({
      collectionEditorCollection: collection,
      collectionEditorModalVisible: true
    });
  }

  renderClozeListeningPanel() {
    if(!this.state.playClozeListeningUrl) {
      return null;
    }

    const { 
      clozeListening,
      collections,
      playClozeListeningUrl,
      progressPerChunk,
      useProgressChunks,
      user
    } = this.state;
    const { isSignedIn } = this.props;

    const {
      numPlaying,
      numReadyForReview,
      uniqueListeningTimeToday,
      uniqueListeningTimePast7Days,
      uniqueListeningTimePast30Days,
      uniqueListeningTimeTotal
    } = clozeListening;

    if(!numPlaying) {
      return null;
    }

    return (
      <ClozeListeningPanel
        isPro={user.isPro}
        numPlaying={numPlaying}
        numReadyForReview={numReadyForReview}
        uniqueListeningTimeToday={uniqueListeningTimeToday}
        uniqueListeningTimePast7Days={uniqueListeningTimePast7Days}
        uniqueListeningTimePast30Days={uniqueListeningTimePast30Days}
        uniqueListeningTimeTotal={uniqueListeningTimeTotal}
        url={playClozeListeningUrl}
      />
    );
  }

  renderAddToCollectionModal() {
    const { addingToCollection, addToCollectionVisible, user } = this.state;

    if(!addToCollectionVisible) {
      return null;
    }

    return (
      <AddToCollectionModal
        collection={addingToCollection}
        collectionsUrl={this.state.collectionsUrl}
        isPro={user.isPro}
        onFile={() => this.addToCollectionModal.hide({ onHidden: () => this.showAddFileToCollectionModal(addingToCollection) })}
        onHidden={() => this.setState({ addingToCollection: null, addToCollectionVisible: false })}
        onManual={() => this.addToCollectionModal.hide({ onHidden: () => this.showAddSentenceToCollectionModal(addingToCollection) })}
        onSearch={() => this.addToCollectionModal.hide({ onHidden: () => this.showSentenceSearchModal(addingToCollection) })}
        onPaste={() => this.addToCollectionModal.hide({ onHidden: () => this.showAddTextToCollectionModal(addingToCollection) })}
        onWords={() => this.addToCollectionModal.hide({ onHidden: () => this.showAddClozeFromWordsToCollectionModal(addingToCollection) })}
        ref={(el) => this.addToCollectionModal = el}
      />
    );
  }

  updateMyCollections() {
    this.setState({ updating: true });
    $.ajax({
      data: { filter: 'mine' },
      url: this.state.collectionsUrl
    })
      .done((data) => {
        const updatedCollectionsHash = data.collections.reduce((h, c) => { h[c.id] = c; return h; }, {});
        let collections = this.state.collections.map((collection) => {
          if(updatedCollectionsHash[collection.id]) {
            const updatedCollection = updatedCollectionsHash[collection.id];
            delete updatedCollectionsHash[collection.id];
            return updatedCollection;
          }
          return collection;
        });
        // add any remaining collections
        collections = collections.concat(Object.values(updatedCollectionsHash));

        this.setState(Object.assign(this.getCollectionsStats(collections), {
          collections,
          updating: false
        }));
      })
      .fail(() => {
        alert('Oh no! There was an error updating the dashboard. Sorry about that. Please refresh the page and let us know if you see this message again.');
        this.setState({ updating: false });
      });
  }

  updateCollection(collection) {
    this.setState({ updating: true });
    $.ajax({
      url: collection.url
    })
      .done((data) => {
        let updated = false;
        const collections = this.state.collections.map((collection) => {
          if(collection.id === data.collection.id) {
            updated = true;
            return data.collection;
          }
          return collection;
        });

        // if it's a new collection
        if(!updated) {
          collections.push(data.collection);
        }

        this.setState(Object.assign(this.getCollectionsStats(collections), {
          collections,
          updating: false
        }));
      })
      .fail(() => {
        alert('Oh no! There was an error updating the dashboard. Sorry about that. Please refresh the page and let us know if you see this message again.');
        this.setState({ updating: false });
      });
  }

  renderManageCollectionModal() {
    const { collectionsUrl, managingCollection, managingCollectionScope, user } = this.state;
    const { baseLanguageEnglishName, targetLanguageCode, targetLanguageEnglishName, targetLanguageIso, targetLanguageName } = this.props;

    if(!managingCollection) {
      return null;
    }

    return (
      <ManageCollectionModal
        baseLanguageEnglishName={baseLanguageEnglishName}
        collectionClozeSentencesUrl={managingCollection.collectionClozeSentencesUrl}
        collectionName={managingCollection.name}
        collectionType={managingCollection.type}
        collectionsUrl={collectionsUrl}
        deleteCollectionProgressUrl={managingCollection.deleteProgressUrl}
        isCollectionEditable={managingCollection.isEditable}
        isPro={user.isPro}
        onHidden={({ hasCopiedSentences }) => {
          const { managingCollection } = this.state;

          this.setState({
            managingCollection: null,
            managingCollectionScope: null
          }, () => {
            // reload the dashboard if copied sentences between collections
            // easier to reload everything vs individual collections
            if(hasCopiedSentences) {
              this.loadLanguagePairing();
              return false;
            }
            this.updateCollection(managingCollection);
          });
        }}
        scope={managingCollectionScope}
        targetLanguageCode={targetLanguageCode}
        targetLanguageEnglishName={targetLanguageEnglishName}
        targetLanguageIso={targetLanguageIso}
        targetLanguageName={targetLanguageName}
      />
    );
  }

  showAddSentenceToCollectionModal(addSentenceToCollection) {
    this.setState({ addSentenceToCollectionVisible: true, addSentenceToCollection });
  }

  onMoreStatsBtnClick() {
    this.setState({ moreStatsVisible: true });
  }

  onSearchBtnClick() {
    this.showSentenceSearchModal();
  }

  showSentenceSearchModal(addSentenceToCollection) {
    // TODO! if not pro, show pro promo
    this.setState({ addSentenceToCollection, sentenceSearchModalVisible: true });
  }

  onReviewSettingsBtnClick() {
    // TODO! if not pro, show pro promo
    this.setState({ reviewSettingsModalVisible: true });
  }

  getLastPlayedCollection() {
    const { collections } = this.state;
    if(!collections) return null;
    const played = collections.filter((c) => c.lastPlayedAt);
    if(!played.length) return null;
    played.sort((a, b) => a.lastPlayedAt > b.lastPlayedAt ? -1 : 1);
    return played[0];
  }

  getPlayOptionsDisplay() {
    let opts = this.state.playOptions;
    if(!opts) {
      try {
        opts = JSON.parse(window.localStorage.getItem('playOptions'));
      } catch(e) {
        // ignore
      }
    }
    if(!opts || !opts.skill) return null;

    const skillLabels = { vocabulary: 'Vocabulary', listening: 'Listening', speaking: 'Speaking' };
    // full_text_input covers both, named by skill - see TodaysPlan/PlayStyleFields.
    const modeLabels = {
      multiple_choice: 'Multiple Choice',
      flashcard: 'Flashcards',
      text_input: 'Text Input',
      full_text_input: opts.skill === 'listening' ? 'Transcribe' : 'Translate'
    };

    return {
      skill: skillLabels[opts.skill] || opts.skill,
      mode: modeLabels[opts.mode] || opts.mode,
      count: opts.count
    };
  }

  buildQuickPlayUrl(collection, opts) {
    const params = new URLSearchParams();
    params.set('skill', opts.skill || 'vocabulary');
    params.set('mode', opts.mode || 'multiple_choice');
    if(opts.count) params.set('count', opts.count);
    return collection.playWebUrl + '?' + params.toString();
  }

  // Like the app, the plan only replaces the old dashboard once a collection has been started.
  isTodaysPlanOn() {
    const { collections, todaysPlanEnabled } = this.state;
    return !!(todaysPlanEnabled && this.props.isSignedIn && collections && collections.some((c) => c.numPlaying > 0));
  }

  requestUnpin(collection) {
    if(!this.isTodaysPlanOn()) {
      this.unpinCollection(collection);
      return;
    }
    trackAmplitudeEvent("unpin_alert_viewed", { collection_name: collection.name });
    this.setState({ unpinConfirmCollection: collection });
  }

  unpinCollection(collection) {
    toggleDashboardCollection({
      collection,
      done: (data) => this.setState({ collections: this.state.collections.map((c) => c.id === collection.id ? data.collection : c) })
    });
  }

  resetCollection(collection) {
    this.setState({ updating: true });
    $.ajax({ method: "post", url: collection.resetProgressUrl })
      .done(() => {
        this.setState({ updating: false });
        this.refreshLanguagePairing();
      })
      .fail(() => {
        this.setState({ updating: false });
        alert("Oh no! There was an error. Sorry about that. Please refresh the page and try again.");
      });
  }

  renderTodaysPlanConfirmModals() {
    const { resetConfirmCollection, unpinConfirmCollection } = this.state;

    return (
      <>
        {unpinConfirmCollection && (
          <ConfirmModal
            confirmText="Unpin"
            message="Reviews for this collection will not be included in your Today's Plan, but you can still complete these reviews when they become available."
            onConfirm={() => this.unpinCollection(unpinConfirmCollection)}
            onHidden={() => this.setState({ unpinConfirmCollection: null })}
            testId="unpin-confirm"
            title="Unpin collection"
          />
        )}
        {resetConfirmCollection && (
          <ConfirmModal
            confirmContext="danger"
            confirmText="OK"
            message={`Are you sure? This will reset all your progress for ${resetConfirmCollection.name}. This action cannot be undone`}
            onConfirm={() => this.resetCollection(resetConfirmCollection)}
            onHidden={() => this.setState({ resetConfirmCollection: null })}
            testId="reset-confirm"
            title="Reset"
          />
        )}
      </>
    );
  }

  sortDashboardCollections(collections) {
    return [...collections].sort((a, b) => {
      if(this.state.dashboardCollectionSort === "lastPlayed") {
        if(!a.lastPlayedAt && !b.lastPlayedAt) return 0;
        if(!a.lastPlayedAt) return 1;
        if(!b.lastPlayedAt) return -1;
        return a.lastPlayedAt > b.lastPlayedAt ? -1 : 1;
      }
      return collectionNameSort(a, b);
    });
  }

  renderDashboardCollectionBody(c) {
    const { maxReviewsPerRound, user } = this.state;

    return (
      <>
        <CollectionProgressBars
          collection={c}
          onShowMasteryHelp={() => this.setState({ masteryHelpCollection: c })}
        />
        {c.collectionUnits && (
          <CollectionUnitProgress
            collectionUnits={c.collectionUnits}
            onSelectUnit={(unit) => this.setState({
              aboutToPlayCollection: c,
              aboutToPlayCollectionUnitId: unit.id
            })}
          />
        )}
        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-5 tw-mb-5">
          <button className="btn btn-block btn-success joystix tw-flex-1 btn-lg" disabled={((c.proOnly || !c.type) && !user.isPro) || (c.numPlaying === c.numSentences && (!maxReviewsPerRound || !c.numReadyForReview))} onClick={() => this.setState({ aboutToPlayCollection: c, aboutToPlayCollectionUnitId: c.collectionUnits?.currentUnitId || null })}>Play</button>
          <button className="btn btn-success-outline joystix tw-flex-1 btn-lg" disabled={!c.numReadyForReview} onClick={() => this.setState({ aboutToPlayCollection: c, aboutToPlayScope: "ready_for_review" })}>Review ({c.numReadyForReview})</button>
        </div>
        <div className="tw-flex tw-flex-row">
          <div className="tw-flex-1">
            {(c.proOnly || !c.type) && !user.isPro && <span className="joystix tw-mr-5">Pro!</span>}
            {c.numPlaying === c.numSentences && !c.numReadyForReview && (
              <div className="text-secondary tw-mr-5">All sentences played and none ready for review — check back later! 🎉</div>
            )}
            {!maxReviewsPerRound && c.numPlaying === c.numSentences && !!c.numReadyForReview && (
              <div className="tw-mr-5">Max reviews per round set to 0 and no more new sentences! 🎉</div>
            )}
            <CollectionPanelPlayedToday
              collection={c}
            />
          </div>
          <div>
            {!!c.numMarkedAsKnown && <>Marked as Known: {c.numMarkedAsKnown}</>}
          </div>
        </div>
      </>
    );
  }
  renderTodaysPlan() {
    const { collections, defaultMaxReviewsPerCollectionPerDay, hasClosedStreakSaveApplied, languagePairingId, playOptions, shouldCelebrateSave, todaysPlanSettingsUrl, user } = this.state;
    const { isSpeakingSkillAvailable, targetLanguageCode, targetLanguageIso, translateReviewsEnabled } = this.props;
    if(!this.isTodaysPlanOn()) return null;

    return (
      <TodaysPlan
        accountCreatedAt={user && user.createdAt}
        collections={collections}
        isAnnouncementBlocked={!!shouldCelebrateSave && !hasClosedStreakSaveApplied}
        defaultMaxReviewsPerCollectionPerDay={defaultMaxReviewsPerCollectionPerDay}
        isPro={!!(user && user.isPro)}
        isSpeakingAvailable={!!(isSpeakingSkillAvailable || (window.clozemaster.speechRecognition.isSupported(targetLanguageIso) && window.clozemaster.speechRecognition.isAvailable()))}
        isSystemTtsAvailable={!!window.clozemaster.systemTtsAvailable(targetLanguageIso, targetLanguageCode)}
        isTranslateReviewsEnabled={!!translateReviewsEnabled}
        languagePairingId={languagePairingId}
        onOpenReviewSettings={() => this.onReviewSettingsBtnClick()}
        onPlanStatusChange={(todaysPlanStatus) => this.setState({ todaysPlanStatus })}
        playOptions={playOptions}
        todaysPlanSettingsUrl={todaysPlanSettingsUrl}
        username={user && user.username}
      />
    );
  }

  renderQuickPlay() {
    const lastPlayed = this.getLastPlayedCollection();
    if(!lastPlayed || this.isTodaysPlanOn()) return null;

    const opts = this.getPlayOptionsDisplay();
    const rawOpts = this.state.playOptions || (() => { try { return JSON.parse(window.localStorage.getItem('playOptions')); } catch(e) { return null; } })();

    const onContinue = () => {
      if(rawOpts && rawOpts.skill) {
        window.location.href = this.buildQuickPlayUrl(lastPlayed, rawOpts);
      } else {
        this.setState({ aboutToPlayCollection: lastPlayed });
      }
    };

    const subtitle = opts ? [opts.skill, opts.count, opts.mode].filter(Boolean).join(' · ') : null;

    // Mobile banner (fixed above bottom nav)
    const mobileBanner = (
      <div
        className="md:tw-hidden tw-fixed tw-left-0 tw-right-0 tw-flex tw-flex-row tw-items-center tw-px-4 tw-py-6 tw-gap-3"
        style={{ bottom: 58, zIndex: 1035, backgroundColor: '#333', borderTop: '1px solid #444' }}
      >
        <div className="tw-flex-1 tw-min-w-0">
          <div className="tw-font-bold tw-text-white tw-truncate">{lastPlayed.name}</div>
          {subtitle && <div className="tw-text-sm tw-truncate" style={{ color: '#aaa' }}>{subtitle}</div>}
        </div>
        <button className="btn btn-success joystix btn-sm tw-shrink-0" onClick={onContinue}>
          Continue <Icon name="chevron-right" />
        </button>
      </div>
    );

    // Desktop panel
    const desktopPanel = (
      <div className="tw-hidden md:tw-block">
        <Panel>
          <div className="tw-flex tw-flex-row tw-items-center tw-gap-4">
            <div className="tw-flex-1 tw-min-w-0 tw-flex tw-gap-4 tw-center tw-items-center tw-flex-wrap">
              <small className="text-secondary joystix">Keep playing!</small>
              <strong>{lastPlayed.name}</strong>
              {subtitle && <small className="text-secondary">{subtitle}</small>}
            </div>
            <button className="btn btn-success joystix" onClick={onContinue} style={{ padding: "10px 40px" }}>
              Continue
            </button>
          </div>
        </Panel>
      </div>
    );

    return { mobileBanner, desktopPanel };
  }

  renderPlayOptionsModal() {
    const { aboutToPlayCollection, aboutToPlayCollectionUnitId, aboutToPlayScope, collections, listeningTrialExpired, playOptions, speakingTrialExpired, user } = this.state;
    const { isSignedIn, isSpeakingSkillAvailable, targetLanguageCode, targetLanguageIso, translateTranscribeAvailable } = this.props;

    if(!aboutToPlayCollection) {
      return null;
    }

    let isListeningSkillAvailable = false;
    if(aboutToPlayCollection.ttsAvailable) {
      isListeningSkillAvailable = true;
    }
    else if(aboutToPlayCollection.name === 'All') {
      if(aboutToPlayScope === 'ready_for_review') {
        isListeningSkillAvailable = collections.filter((c) => c.numReadyForReview).every((c) => c.ttsAvailable);
      }
      else if(aboutToPlayScope === 'favorited') {
        isListeningSkillAvailable = collections.filter((c) => c.numFavorited).every((c) => c.ttsAvailable);
      }
    }
    // allow pro users to use system tts as well
    isListeningSkillAvailable = isListeningSkillAvailable ||
      window.clozemaster.systemTtsAvailable(targetLanguageIso, targetLanguageCode);

    return (
      <PlayOptionsModal
        collection={aboutToPlayCollection}
        collectionUnitId={aboutToPlayCollectionUnitId}
        isPro={user.isPro}
        isListeningSkillAvailable={isListeningSkillAvailable}
        isSignedIn={isSignedIn}
        isSpeakingSkillAvailable={isSpeakingSkillAvailable}
        listeningTrialExpired={listeningTrialExpired}
        onHidden={() => this.setState({ aboutToPlayCollection: null, aboutToPlayCollectionUnitId: null, aboutToPlayScope: null })}
        playOptions={playOptions}
        scope={aboutToPlayScope}
        translateReviewsEnabled={this.props.translateReviewsEnabled}
        speakingTrialExpired={speakingTrialExpired}
        targetLanguageIso={targetLanguageIso}
        translateTranscribeAvailable={translateTranscribeAvailable}
      />
    );
  }

  renderPast7DaysChart() {
    const { dailyStatsUrl, past7DaysNewReview, user } = this.state;
    const { isSignedIn } = this.props;
    const numPlayedToday = past7DaysNewReview[6].numNew + past7DaysNewReview[6].numReview;

    return (
      <div>
        <div className="text-secondary" style={{ marginBottom: 4 }}>{numPlayedToday} sentences played today</div>
        <div style={{ position: "relative", height: 100, margin: "10px 0" }}>
          <canvas ref={(el) => this.past7DaysCanvas = el} />
        </div>
      </div>
    );
  }

  getPlaysGrowthDerivedStats() {
    return getPlaysGrowthDerivedStats(this.state);
  }

  initPlaysGrowthChart() {
    if(!this.playsGrowthCanvas) return;
    const derived = this.getPlaysGrowthDerivedStats();
    if(!derived) return;

    if(this.playsGrowthChart) {
      this.playsGrowthChart.destroy();
      this.playsGrowthChart = null;
    }

    const ctx = this.playsGrowthCanvas.getContext('2d');
    if(!ctx) return; // jsdom returns null in tests

    // 90 past days + 7 forecast = 97 labels
    const labels = [...derived.dateLabels, ...derived.forecastLabels];
    const actualLen = derived.cumulative.length; // 90
    const lastActual = derived.cumulative[actualLen - 1];

    // Actual dataset: 90 real values + 7 nulls (gap)
    const actualData = [...derived.cumulative, ...new Array(derived.forecastCumulative.length).fill(null)];

    // Forecast dataset: 89 nulls, then last actual (connector), then 7 forecasted values
    const forecastData = new Array(actualLen - 1).fill(null);
    forecastData.push(lastActual);
    derived.forecastCumulative.forEach((v) => forecastData.push(v));

    // Adaptive Y scale (don't start at 0)
    const allVals = [...derived.cumulative, ...derived.forecastCumulative];
    const minVal = Math.min(...allVals);
    const maxVal = Math.max(...allVals);
    const dataRange = Math.max(maxVal - minVal, 1);
    const niceStepCandidates = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000];
    const idealStep = dataRange / 5;
    const stepWidth = niceStepCandidates.find((s) => s >= idealStep) || 100000;
    const yMin = Math.max(0, Math.floor(minVal / stepWidth) * stepWidth - stepWidth);
    const yMax = Math.ceil(maxVal / stepWidth) * stepWidth + stepWidth;

    this.playsGrowthChart = new ChartV4(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: "Actual",
            data: actualData,
            backgroundColor: "rgba(92,184,92,0.15)",
            borderColor: "rgba(92,184,92,1)",
            pointBackgroundColor: "rgba(92,184,92,1)",
            pointBorderColor: "rgba(92,184,92,1)",
            pointHoverBackgroundColor: "rgba(92,184,92,1)",
            pointHoverBorderColor: "rgba(92,184,92,1)",
            borderWidth: 2,
            pointRadius: 0,
            pointHitRadius: 8,
            tension: 0,
            fill: true,
            spanGaps: false
          },
          {
            label: "Forecast",
            data: forecastData,
            backgroundColor: "rgba(92,184,92,0.3)",
            borderColor: "rgba(92,184,92,0.6)",
            // borderDash: [5, 5],
            // borderWidth: 2,
            pointBackgroundColor: "rgba(92,184,92,1)",
            // pointBorderColor: "#fff",
            // pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(92,184,92,0.6)",
            pointRadius: 3,
            pointHitRadius: 8,
            tension: 0,
            fill: true,
            spanGaps: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'nearest', intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => items[0].label,
              label: (item) => {
                const prefix = item.datasetIndex === 1 && item.dataIndex > actualLen - 1 ? "Forecast: " : "";
                return ` ${prefix}${Number(item.parsed.y).toLocaleString()} total plays`;
              }
            }
          }
        },
        scales: {
          x: { display: false },
          y: {
            min: yMin,
            max: yMax,
            ticks: {
              stepSize: stepWidth,
              color: "rgba(150,150,150,0.7)",
              font: { size: 10 }
            },
            grid: { color: "rgba(150,150,150,0.1)" }
          }
        }
      }
    });
  }

  renderExtraData() {
    const { playsGrowth, uccsStats } = this.state;
    if(!playsGrowth || !uccsStats) return null;

    const derived = this.getPlaysGrowthDerivedStats();
    if(!derived) return null;

    const byLevel = uccsStats.byLevel || {};
    const levelRows = [
      { level: 0, label: "0%",   count: byLevel[0] || 0 },
      { level: 1, label: "25%",  count: byLevel[1] || 0 },
      { level: 2, label: "50%",  count: byLevel[2] || 0 },
      { level: 3, label: "75%",  count: byLevel[3] || 0 },
      { level: 4, label: "100%", count: byLevel[4] || 0 }
    ];
    const totalDeck = uccsStats.total || 0;
    const checkmarksEarned = levelRows.reduce((sum, r) => sum + r.level * r.count, 0);
    const totalCheckmarks = totalDeck * 4;
    const masteryPct = totalCheckmarks > 0 ? (checkmarksEarned / totalCheckmarks) * 100 : 0;

    const sectionTitle = (text) => (
      <div className="text-uppercase" style={{ fontWeight: "bold" }}>{text}</div>
    );

    const deckCollection = {
      name: "Sentences I'm learning",
      numSentences: totalDeck,
      numPlaying: totalDeck,
      levelCounts: byLevel
    };

    return (
      <>
        <Panel>
          <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
            <div className="tw-flex-1">
              {sectionTitle("Total Plays")}
              <div className="joystix" style={{ fontSize: 48, lineHeight: 1, margin: "8px 0" }}>
                {derived.totalPlayed.toLocaleString()}
              </div>
              <div style={{ color: "#5cb85c", marginBottom: 16 }}>
                +{derived.playedThisWeek.toLocaleString()} this week
              </div>
            </div>
            <div className="tw-hidden md:tw-block text-secondary" style={{ textAlign: "right" }}>
              Every sentence played is another step towards fluency!
            </div>
          </div>
          <div className="tw-flex tw-flex-row tw-justify-between" style={{ marginBottom: 6 }}>
            <span>Next milestone: <strong>{derived.nextMilestone.toLocaleString()} plays</strong></span>
            <span className="text-secondary">
              {derived.toGo.toLocaleString()} to go
              {derived.daysToGo != null && <>. Forecasted: {derived.daysToGo} day{derived.daysToGo === 1 ? "" : "s"}</>}{/* at current pace*/}
            </span>
          </div>
          <div className="progress" style={{ height: 10, marginBottom: 12 }}>
            <div className="progress-bar progress-bar-success" style={{ width: derived.milestonePct + "%" }} />
          </div>
          <div className="tw-flex tw-flex-row tw-gap-2 tw-flex-wrap" style={{ marginBottom: 16 }}>
            <span style={{ background: "rgba(92,184,92,0.15)", color: "#5cb85c", padding: "4px 12px", borderRadius: 12, fontSize: 13 }}>
              {derived.newThisWeek.toLocaleString()} new this week
            </span>
            <span style={{ background: "rgba(92,184,92,0.15)", color: "#5cb85c", padding: "4px 12px", borderRadius: 12, fontSize: 13 }}>
              {derived.reviewsThisWeek.toLocaleString()} reviews this week
            </span>
          </div>

          <div style={{ position: "relative", height: 220, marginBottom: 12 }}>
            <canvas ref={(el) => this.playsGrowthCanvas = el} />
          </div>

          <div className="tw-flex tw-flex-row tw-flex-wrap" style={{ gap: 16, fontSize: 13, marginBottom: 4 }}>
            {/*
            <div style={{ flex: 1, minWidth: 90 }}>
              <div className="text-secondary text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>90 days ago</div>
              <div className="joystix">{derived.total90dAgo.toLocaleString()}</div>
            </div>
            */}
            <div style={{ flex: 1, minWidth: 90, textAlign: "center" }}>
              <div className="text-secondary text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>30 days ago</div>
              <div className="joystix">{derived.total30dAgo.toLocaleString()}</div>
            </div>
            <div style={{ flex: 1, minWidth: 90, textAlign: "center" }}>
              <div className="text-secondary text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>Today</div>
              <div className="joystix">{derived.totalPlayed.toLocaleString()}</div>
            </div>
            <div style={{ flex: 1, minWidth: 90, textAlign: "center" }}>
              <div className="text-uppercase" style={{ fontSize: 11, letterSpacing: 1, color: "#5cb85c" }}>In 7 days</div>
              <div className="joystix" style={{ color: "#5cb85c" }}>~{derived.projectedIn7Days.toLocaleString()}</div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <small className="text-secondary" style={{ display: "block", fontStyle: "italic" }}>
              Forecast based on past 7-day average of {(Math.round(derived.past7DayPace * 10) / 10).toLocaleString()} sentences played per day
            </small>
          </div>
        </Panel>

        <Panel>
          <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
            <div className="tw-flex-1">
              {sectionTitle("Sentences I'm learning")}
              <div className="joystix" style={{ fontSize: 48, lineHeight: 1, margin: "8px 0" }}>
                {totalDeck.toLocaleString()}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>{uccsStats.uniqueTokens.toLocaleString()}</strong> unique words
              </div>
              <div style={{ color: "#5cb85c" }}>
                +{uccsStats.addedThisWeek.toLocaleString()} added this week
              </div>
            </div>
            <div style={{ flexBasis: 360, minWidth: 260 }}>
              <div>
                How well do I know them? <strong>{masteryPct.toFixed(1)}% Mastery{" "}</strong>
                <button
                  className="btn btn-default btn-xs"
                  onClick={() => this.setState({ masteryHelpCollection: deckCollection, masteryHelpScope: "deck" })}
                >
                  <Icon name="question-sign" />
                </button>
              </div>
              <div style={{ marginTop: 8 }}>
                {levelRows.map((r) => {
                  const pct = totalDeck > 0 ? (r.count / totalDeck) * 100 : 0;
                  return (
                    <div key={r.label} className="tw-flex tw-flex-row tw-items-center tw-gap-2" style={{ marginBottom: 4 }}>
                      <div style={{ width: 40, fontSize: 13 }} className="text-secondary">{r.label}</div>
                      <div style={{ display: "flex", gap: 2, alignItems: "center" }}>
                        {[0, 1, 2, 3].map((i) => (
                          <Icon
                            key={i}
                            name="ok-circle"
                            style={{ color: i < r.level ? "#5cb85c" : "#666", fontSize: 12 }}
                          />
                        ))}
                      </div>
                      <div style={{ flex: 1, background: "rgba(255,255,255,0.06)", height: 10, borderRadius: 5, overflow: "hidden" }}>
                        <div style={{ width: pct + "%", background: "#5cb85c", height: "100%" }} />
                      </div>
                      <div style={{ width: 50, textAlign: "right", fontSize: 13 }}>{r.count.toLocaleString()}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Panel>
      </>
    );
  }

  renderReviewSettingsModal() {
    if(!this.state.reviewSettingsModalVisible) {
      return null;
    }

    return (
      <ReviewSettingsModal
        isPro={this.state.user.isPro}
        onHidden={() => this.setState({ reviewSettingsModalVisible: false }, () => this.refreshLanguagePairing())}
        url={this.state.reviewSettingsUrl}
      />
    );
  }

  renderRankingsModal() {
    if(!this.state.rankingsModalVisible) {
      return null;
    }

    const {
      baseLanguageFlagIso,
      targetLanguageFlagIso
    } = this.props;

    const { rankingsUrl } = this.state;

    return (
      <RankingsModal
        baseLanguageFlagIso={baseLanguageFlagIso}
        onHidden={() => this.setState({ rankingsModalVisible: false })}
        rankingsUrl={rankingsUrl}
        targetLanguageFlagIso={targetLanguageFlagIso}
      />
    );
  }

  renderMoreStatsModal() {
    if(!this.state.moreStatsVisible) {
      return null;
    }

    return (
      <MoreStatsModal
        isPro={this.state.user.isPro}
        moreStatsUrl={this.state.moreStatsUrl}
        onHidden={() => this.setState({ moreStatsVisible: false })}
      />
    );
  }

  showAddClozeFromWordsToCollectionModal(addSentencesToCollection) {
    this.setState({
      addSentencesToCollection,
      addClozeFromWordsToCollectionModalVisible: true,
    });
  }

  showAddTextToCollectionModal(addSentencesToCollection) {
    this.setState({
      addSentencesToCollection,
      addTextToCollectionModalVisible: true,
    });
  }

  showAddFileToCollectionModal(addSentencesToCollection) {
    this.setState({
      addSentencesToCollection,
      addFileToCollectionModalVisible: true,
    });
  }

  renderAddClozeFromWordsToCollectionModal() {
    const { addSentencesToCollection, addClozeFromWordsToCollectionModalVisible, collectionsUrl, clozeFromWordsUrl, user } = this.state;

    if(!addClozeFromWordsToCollectionModalVisible) {
      return null;
    }

    return (
      <AddClozeFromWordsToCollectionModal
        collection={addSentencesToCollection}
        isPro={user.isPro}
        onHidden={() => this.setState({ addSentencesToCollection: null, addClozeFromWordsToCollectionModalVisible: false })}
        onSentencesAdded={() => {
          this.updateCollection(addSentencesToCollection);
        }}
        clozeFromWordsUrl={clozeFromWordsUrl}
        ref={(el) => this.addClozeFromWordsToCollectionModal = el}
      />
    );
  }

  renderAddTextToCollectionModal() {
    const { addSentencesToCollection, addTextToCollectionModalVisible, collectionsUrl, quickClozeUrl, user } = this.state;

    if(!addTextToCollectionModalVisible) {
      return null;
    }

    return (
      <AddTextToCollectionModal
        collection={addSentencesToCollection}
        isPro={user.isPro}
        onHidden={() => this.setState({ addSentencesToCollection: null, addTextToCollectionModalVisible: false })}
        onSentencesAdded={() => {
          this.updateCollection(addSentencesToCollection);
        }}
        quickClozeUrl={quickClozeUrl}
        ref={(el) => this.addTextToCollectionModal = el}
      />
    );
  }

  renderAddFileToCollectionModal() {
    const { addSentencesToCollection, addFileToCollectionModalVisible, collectionsUrl, collectionFileImportUrl, user } = this.state;

    if(!addFileToCollectionModalVisible) {
      return null;
    }

    return (
      <AddFileToCollectionModal
        collection={addSentencesToCollection}
        collectionFileImportUrl={collectionFileImportUrl}
        isPro={user.isPro}
        onHidden={() => this.setState({ addSentencesToCollection: null, addFileToCollectionModalVisible: false })}
        onSentencesAdded={() => {
          this.updateCollection(addSentencesToCollection);
        }}
        ref={(el) => this.addFileToCollectionModal = el}
      />
    );
  }

  renderSentenceSearchModal() {
    if(!this.state.sentenceSearchModalVisible) {
      return null;
    }

    return (
      <ClozeSentenceSearchModal 
        collectionsUrl={this.state.collectionsUrl}
        isPro={this.state.user.isPro}
        initialSelectedCollectionId={this.state.addSentenceToCollection && this.state.addSentenceToCollection.id}
        nextReviewByLevel={this.state.nextReviewByLevel}
        onHidden={() => {
          this.updateMyCollections();
          this.setState({ sentenceSearchModalVisible: false, addSentenceToCollection: null });
        }}
        url={this.state.clozeSentencesUrl}
      />
    );
  }

  renderCollectionEditorModal() {
    if(!this.state.collectionEditorModalVisible) {
      return null;
    }

    const {
      collectionEditorCollection,
      collectionsUrl,
      user
    } = this.state;

    return (
      <CollectionEditorModal
        collection={collectionEditorCollection}
        collectionsUrl={collectionsUrl}
        isPro={user.isPro}
        onCreate={(collection) => {
          const collections = JSON.parse(JSON.stringify(this.state.collections));
          collections.unshift(collection);
          this.setState({ collections });
        }}
        onDelete={(collection) => {
          const collections = JSON.parse(JSON.stringify(this.state.collections));
          for(let i = 0, n = collections.length; i < n; i++) {
            if(collections[i].id === collection.id) {
              collections.splice(i, 1);
              break;
            }
          }
          this.setState({ collections });
        }}
        onHidden={() => {
          this.setState({
            collectionEditorCollection: null,
            collectionEditorModalVisible: false
          });
        }}
        onUpdate={(collection) => {
          const collections = JSON.parse(JSON.stringify(this.state.collections));
          for(let i = 0, n = collections.length; i < n; i++) {
            if(collections[i].id === collection.id) {
              collections[i] = collection;
              break;
            }
          }
          this.setState({ collections });
        }}
      />
    );
  }

  renderAddSentenceToCollectionModal() {
    if(!this.state.addSentenceToCollectionVisible) {
      return null;
    }

    return (
      <AddSentenceToCollectionModal
        collectionsUrl={this.state.collectionsUrl}
        initialSelectedCollectionId={this.state.addSentenceToCollection && this.state.addSentenceToCollection.id}
        isPro={this.state.user.isPro}
        nextReviewByLevel={this.state.nextReviewByLevel}
        onHidden={() => this.setState({ addSentenceToCollectionVisible: false, addSentenceToCollection: null })}
        onSentenceAdded={(collectionClozeSentence, collection) => {
          this.updateCollection(collection);
          this.addSentenceToCollectionModal.reset();
          // this.addSentenceToCollectionModal.hide();
        }}
        ref={(el) => this.addSentenceToCollectionModal = el}
      />
    );
  }

  renderCollectionTypeModal() {
    const { collectionTypeModal, collections } = this.state;

    if(collectionTypeModal) {
      const readableCollectionType = this.readableCollectionType(collectionTypeModal);
      return (
        <Modal
          footer={<ModalFooterCloseBtn text="Close" />}
          onHidden={() => this.setState({ collectionTypeModal: null })}
          ref={(el) => this.collectionTypeModalRef = el}
          title={`${readableCollectionType} Progress`}
        >
          {collections.filter((c) => c.type === collectionTypeModal).map((c) => (
            <div>
              <p className="tw-flex tw-flex-row tw-justify-between"><strong>{c.name}</strong> {c.numSentences.toLocaleString()} sentences</p>
              <CollectionProgressBars
                collection={c}
                onShowMasteryHelp={() => this.setState({ masteryHelpCollection: c })}
              />
            </div>
          ))}
          <button
            className="btn btn-success joystix btn-block"
            onClick={() => {
              this.setState({ activeTab: "collections" }, () => {
                this.collectionTypeModalRef && this.collectionTypeModalRef.hide();
                const e = document.querySelector(`[data-type="${collectionTypeModal}"]`);
                if(e) {
                  e.scrollIntoView({ behavior: "smooth" });
                }
                if(!e.classList.contains("open")) {
                  e.querySelector(".btn.toggle-open").click();
                }
              }); 
            }}
          >
            Go to <span className="tw-hidden md:tw-inline">{readableCollectionType} </span>Collections
          </button>
        </Modal>
      );
    }
  }

  renderCollectionReviewSettingsModal() {
    const { collectionReviewSettingsVisible } = this.state;

    if(!collectionReviewSettingsVisible) { 
      return null;
    }

    const { user } = this.state;

    return (
      <CollectionReviewSettingsModal
        collectionName={collectionReviewSettingsVisible.name}
        isPro={user.isPro}
        onHidden={() => this.setState({ collectionReviewSettingsVisible: false }, () => this.refreshLanguagePairing())}
        url={""}
      />
    );
  }

  renderModals() {
    return (
      <>
        <StreakSaveAppliedModalContainer
          context={this.state.streakSaveAppliedContext}
          onHidden={() => this.setState({ hasClosedStreakSaveApplied: true, streakSaveAppliedVisible: false, streakSaveAppliedContext: null })}
        />
        {this.renderPlayOptionsModal()}
        {this.renderManageCollectionModal()}
        {this.renderAddToCollectionModal()}
        {this.renderAddSentenceToCollectionModal()}
        {this.renderAddTextToCollectionModal()}
        {this.renderAddClozeFromWordsToCollectionModal()}
        {this.renderAddFileToCollectionModal()}
        {this.renderCollectionEditorModal()}
        {this.renderCollectionReviewSettingsModal()}
        {this.renderCollectionTypeModal()}
        {this.renderFavoritesModal()}
        {this.renderDownloadFavoritesModal()}
        {this.renderReviewSettingsModal()}
        {this.renderRankingsModal()}
        {this.renderSentenceSearchModal()}
        {this.renderMoreStatsModal()}
        {this.renderLanguagePairingSettingsModal()}
        {this.renderDeleteLanguagePairingModal()}
        {this.renderResetProgressModal()}
        {this.renderTodaysPlanConfirmModals()}
        {this.state.masteryHelpCollection && (
          <MasteryHelpModal
            collection={this.state.masteryHelpCollection}
            nextReviewByLevel={this.state.nextReviewByLevel}
            scope={this.state.masteryHelpScope || "collection"}
            onHidden={() => this.setState({ masteryHelpCollection: null, masteryHelpScope: null })}
          />
        )}
      </>
    );
  }

  renderResetProgressModal() {
    const {
      baseLanguageFlagIso,
      baseLanguageName,
      targetLanguageFlagIso,
      targetLanguageName
    } = this.props;

    const { collections, resetProgressUrl } = this.state;

    return (
      <ResetProgressModal
        baseLanguageFlagIso={baseLanguageFlagIso}
        baseLanguageName={baseLanguageName}
        collections={collections.filter((c) => c.playing)}
        resetProgressUrl={resetProgressUrl}
        onResetLanguagePairing={() => this.setState({ updating: true })}
        onResetCollection={() => this.setState({ updating: true })}
        targetLanguageFlagIso={targetLanguageFlagIso}
        targetLanguageName={targetLanguageName}
      />
    );
  }

  renderDeleteLanguagePairingModal() {
    const {
      baseLanguageFlagIso,
      baseLanguageName,
      languagePairingUrl,
      targetLanguageFlagIso,
      targetLanguageName
    } = this.props;

    return (
      <DeleteLanguagePairingModal
        baseLanguageFlagIso={baseLanguageFlagIso}
        baseLanguageName={baseLanguageName}
        languagePairingUrl={languagePairingUrl}
        onDeleteLanguagePairing={() => this.setState({ updating: true })}
        targetLanguageFlagIso={targetLanguageFlagIso}
        targetLanguageName={targetLanguageName}
      />
    );
  }

  renderLanguagePairingSettingsModal() {
    const {
      baseLanguageFlagIso,
      baseLanguageName,
      languagePairingUrl,
      targetLanguageFlagIso,
      targetLanguageName
    } = this.props;

    const {
      gameSettingsUrl,
      progressPerChunk,
      useProgressChunks
    } = this.state;

    return (
      <LanguagePairingSettingsModal
        baseLanguageFlagIso={baseLanguageFlagIso}
        baseLanguageName={baseLanguageName}
        gameSettingsUrl={gameSettingsUrl}
        languagePairingUrl={languagePairingUrl}
        onProgressChunksChange={({ progressPerChunk, useProgressChunks }) => {
          this.setState({
            progressPerChunk,
            useProgressChunks
          });
        }}
        progressPerChunk={progressPerChunk}
        targetLanguageFlagIso={targetLanguageFlagIso}
        targetLanguageName={targetLanguageName}
        useProgressChunks={useProgressChunks}
      />
    );
  }

  readableCollectionType(type) {
    switch(type) {
      case "FrequencyCollection": 
        return "Most Common Words";
      case "FastTrackV2Collection":
        return "Fluency Fast Track";
      case "GrammarCollection":
        return "Grammar Challenge";
      default:
        return "";
    }
  }

  // daily bonus
  // - on language pairing show, find or create for date for lp, 
  // - mode = listening, vocabulary (eventually speaking once merged in)
  // - skill = multiple choice, text input
  // - collection? cloze-reading? radio?

  //----------------------------------
  // X level
  // X leaderboard
  // X favorites
  // X username menu
  // X language pairings menu
  // X hook up search + add
  // X review settings visible but disabled for non pro
  // X state if no collections being played
  // X collection dropdown
  // X reset progress
  // X delete language pairing
  // X stretch to fill page
  // X dark mode
  // X dark mode as user / global setting! NOT PER LP
  // X mobile view dark mode
  // X collections list pin to dashboard in dropdown, simple for mobile view
  // X mobile dashboard buttons overlap fixed bottom nav
  // O daily bonus (including on round results)
  // X left sidebar pro promo, blog, social
  // X daily bonus sub for now - played today?
  // X how are collections ordered on dashboard? probably alphabetical? or last played? but then jumpy? custom order?
  // X mobile width progress bar on separate line
  // X collection design if pro only and not pro
  // X streak days played toggle (including on profile and round results)
  // X mobile viewport
  // - collections, stats, cloze-reading
  // - migrate cloze-listening
  // - smoke test
  // - move languages dropdown to right
  // - confirm email notification
  // - sale notification
  // - fftv2 notification
  // X marked as known count

  renderActiveTab() {
    const {
      activeTab,
      collectionsUrl,
      // compInputsUrl,
      discoverMediasUrl,
      user
    } = this.state;

    // if(activeTab === "comp-inputs") {
    //   return <CompInputs url={compInputsUrl} />;
    // }

    if(activeTab === "discover") {
      return (
        <Discover
          collectionsUrl={collectionsUrl}
          isPro={user.isPro}
          url={discoverMediasUrl}
        />
      );
    }

    if(activeTab === "collections") {
      const {
        collections,
        collectionGroupings,
      } = this.state;

      const f = (t) => collections.filter(({ type }) => type === t);
      const cefrCollections = f("CefrCollection").sort((a, b) => {
        if(a.presentationOrder !== b.presentationOrder) {
          return (a.presentationOrder || 0) - (b.presentationOrder || 0);
        }
        return a.name.localeCompare(b.name);
      });
      const clozeListeningCollections = f("ClozeListeningCollection");
      const core1kCollection = f("Core1kCollection");
      const customCollections = f(null);
      const fastTrackCollection = f("FastTrackCollection");
      const fastTrackV2Collections = f("FastTrackV2Collection");
      const frequencyCollections = f("FrequencyCollection");
      const grammarCollections = f("GrammarCollection");
      const nsfwCollection = f("NsfwCollection");
      const randomCollection = f("RandomCollection");
      // what a mess
      // change back to const after everyday life experiment
      let otherCollections = collections.filter(({ type }) => (
        type && ![
          "ClozeListeningCollection",
          "Core1kCollection",
          "CefrCollection",
          "FastTrackCollection",
          "FastTrackV2Collection",
          "FrequencyCollection",
          "GrammarCollection",
          "NsfwCollection",
          "RandomCollection"
        ].includes(type)
      )).sort((a, b) => a.name.localeCompare(b.name));

      const fastTrackProps = fastTrackCollection.length ? {
        collections: fastTrackCollection,
        description: `Play ${fastTrackCollection[0].numSentences.toLocaleString()} sentences with ${fastTrackCollection[0].numSentences.toLocaleString()} unique cloze-words in order of difficulty. Fast and efficient language learning. Each word in each sentence is matched against a frequency list (a list of words ordered by how often they're likely to occur). The most difficult (least common) word is then selected as the missing word. The Fast Track has one sentence for each missing word, and the sentences are played in order of difficulty, so you're always making progress.`,
        name: fastTrackCollection.name
      } : {};

      const panels = [];

      let firstSet = false;

      if(this.props.everydayLifeFirst) {
        let collection = null;
        if((collection = otherCollections.find((c) => c.name === "Everyday Life"))) {
          panels.push({
            collections: [collection],
            first: true,
            name: collection.name
          });
          otherCollections = otherCollections.filter((c) => c.name !== "Everyday Life");
          firstSet = true;
        }
      }

      if(fastTrackV2Collections.length) {
        panels.push({
          collections: fastTrackV2Collections,
          collectionType: "FastTrackV2Collection",
          description: fastTrackV2Collections.length > 10 ? `Expand your vocabulary quickly and efficiently - play through ${fastTrackV2Collections.length} collections by word frequency: from the most common words to the least common.` :
            `Expand your vocabulary quickly and efficiently - play through ${fastTrackV2Collections.length} collections in order of difficulty, from sentences with more common vocabulary to sentences with less common vocabulary.`,
          first: !firstSet,
          name: "Fluency Fast Track"
        });
        firstSet = true;
      }
      else if(fastTrackCollection.length) {
        panels.push(Object.assign({}, fastTrackProps, { first: !firstSet }));
        firstSet = true;
      }

      if(cefrCollections.length) {
        panels.push({
          collections: cefrCollections,
          collectionType: "CefrCollection",
          description: "Play through sentences mapped to the Common European Framework of Reference for Languages (CEFR) grouped by everyday scenarios, topics, and grammar.",
          first: !firstSet,
          name: "Skill Levels (CEFR)"
        });
        firstSet = true;
      }

      panels.push({
        collections: frequencyCollections,
        collectionType: "FrequencyCollection",
        first: !fastTrackV2Collections.length && !fastTrackCollection.length,
        name: "Most Common Words"
      });

      panels.push({
        collections: core1kCollection,
        name: core1kCollection.name
      });

      panels.push({
        collections: grammarCollections,
        collectionType: "GrammarCollection",
        name: "Grammar Challenges"
      });

      collectionGroupings.forEach((grouping) => {
        panels.push({
          collections: collections.filter((c) => c.collectionGroupingId === grouping.id),
          name: grouping.name
        });
      });
      
      if(otherCollections.length) {
        otherCollections.forEach((c) => panels.push({
          collections: [c],
          name: c.name
        }));
      }

      panels.push({
        collections: nsfwCollection,
        name: "NSFW Collection"
      });

      if(fastTrackV2Collections.length && fastTrackCollection.length) {
        panels.push(fastTrackProps);
      }

      panels.push({
        collections: randomCollection,
        description: "A collection of randomly selected sentences, played in random order.",
        name: randomCollection.name
      });

      panels.push({
        collections: customCollections,
        customCollectionsPanel: true,
        description: "Play shared collections of cloze sentences or create your own!",
        name: "Custom Collections"
      });

      return (
        <>
          {panels.map((props, i) => (
            <CollectionsPanel
              {...props}
              isPro={user.isPro}
              key={i}
              manage={(collection) => this.setState({ managingCollection: collection })}
              nextReviewByLevel={this.state.nextReviewByLevel}
              play={({ collection, scope = null, collectionUnitId = null }) => this.setState({ aboutToPlayCollection: collection, aboutToPlayCollectionUnitId: collectionUnitId, aboutToPlayScope: scope })}
              requestUnpin={this.isTodaysPlanOn() ? (collection) => this.requestUnpin(collection) : null}
              sharedCollectionsUrl={this.state.sharedCollectionsUrl}
              showAddToCollectionModal={(collection) => this.showAddToCollectionModal(collection)}
              showCollectionEditor={(collection) => this.showCollectionEditor(collection)}
              totalNumPlaying={collections.reduce((t, c) => t + c.numPlaying, 0)}
              update={(collection) => this.setState({ collections: collections.map((c) => c.id === collection.id ? collection : c) })}
            />
          ))}
          {this.renderClozeListeningPanel()}
        </>
      );
    }

    const {
      languagePairingUrl
    } = this.props;

    const {
      collections,
      currentLevelPoints,
      currentStreakDays,
      currentStreakIncludesToday,
      currentWeekLeaderboardRank,
      dailyGoalHoursLeftToday,
      dailyGoalPointsPerDay,
      dailyGoalUrl,
      dailyReminderEmail,
      dailyReminderEmailUrl,
      dailyStatsUrl,
      dashboardCollectionSort,
      daysPlayedCount,
      gameSettingsUrl,
      languagePairingNotification,
      level,
      nextLevelPoints,
      numFavorited,
      numMastered,
      numPlaying,
      numPointsToday,
      numReadyForReview,
      past7DaysNewReview,
      playLanguagePairingWebUrl,
      reviewPickerVisible,
      showDaysPlayedInsteadOfStreak,
      statsExpanded,
      score,
      streakSaveBalance
    } = this.state;

    return (
      <>
        {languagePairingNotification && (
          <LanguagePairingNotification
            languagePairingNotification={languagePairingNotification}
            onPlayClick={(collectionId) => this.setState({ aboutToPlayCollection: collections.find((c) => c.id === collectionId) })}
          />
        )}

        {this.state.todaysPlanEnabled && this.renderTodaysPlan()}

        {this.renderQuickPlay()?.desktopPanel}

        {/* Review + Streak */}
        <Panel>
          <div className="tw-flex tw-flex-row tw-items-start tw-gap-4 md:tw-gap-8">
            {!this.isTodaysPlanOn() && <>
            {/* Review */}
            <div className="tw-flex-1" data-testid="ready-for-review-panel">
              <div className="tw-flex tw-flex-row tw-items-start">
                <div className="tw-font-bold tw-flex-1 tw-uppercase">Ready for Review</div>
                <button className="btn btn-default btn-xs review-settings" onClick={() => this.onReviewSettingsBtnClick()}><Icon name="cog" /></button>
              </div>
              <div className="joystix tw-text-4xl tw-my-2.5" data-testid="ready-for-review">
                {numReadyForReview.toLocaleString()} {past7DaysNewReview[6].numReview > 0 && numReadyForReview === 0 && <>🙌</>}
              </div>
              <button
                className={`btn btn-success${numReadyForReview ? "" : "-outline"} joystix btn-block btn-md`}
                disabled={!numReadyForReview}
                onClick={() => {
                  const reviewCollections = collections.filter((c) => c.numReadyForReview);
                  if(reviewCollections.length > 1) {
                    this.setState({ reviewPickerVisible: true });
                  } else {
                    this.setState({ aboutToPlayCollection: reviewCollections[0], aboutToPlayScope: 'ready_for_review' });
                  }
                }}
              >
                Review
              </button>
              {reviewPickerVisible && (
                <Modal
                  onHidden={() => this.setState({ reviewPickerVisible: false })}
                  ref={(el) => this.reviewPickerModal = el}
                  title="Ready for Review"
                >
                  <button
                    className="btn btn-lg btn-success btn-block joystix tw-mb-4"
                    onClick={() => {
                      this.reviewPickerModal.hide({
                        onHidden: () => this.setState({
                          aboutToPlayCollection: { name: 'All', playWebUrl: playLanguagePairingWebUrl },
                          aboutToPlayScope: 'ready_for_review'
                        })
                      });
                    }}
                  >
                    Review All <Icon name="chevron-right" />
                  </button>
                  {collections.filter((c) => c.numReadyForReview).map((c) => (
                    <div key={c.id} className="review-picker-item">
                      <div className="tw-flex-1">
                        <span className="tw-font-bold">{c.name}</span>
                        <span className="tw-ml-4 joystix">{c.numReadyForReview}</span>
                      </div>
                      <button
                        className="btn btn-success btn-sm joystix"
                        onClick={() => {
                          this.reviewPickerModal.hide({
                            onHidden: () => this.setState({
                              aboutToPlayCollection: c,
                              aboutToPlayScope: 'ready_for_review'
                            })
                          });
                        }}
                      >
                        Review <Icon name="chevron-right" />
                      </button>
                    </div>
                  ))}
                </Modal>
              )}
            </div>

            {/* Divider */}
            <div className="tw-border-0 tw-border-l tw-border-solid tw-border-divider tw-self-stretch dashboard-panel-divider"></div>
            </>}

            {/* Streak */}
            <div className="tw-flex-1">
              <div className="tw-flex tw-flex-row tw-items-start">
                <div className="tw-font-bold tw-flex-1 tw-uppercase">
                  {showDaysPlayedInsteadOfStreak ? "Days Played" : "Streak"} <small style={{ fontWeight: "normal" }}><a href="/settings#timezone">({this.props.timeZone})</a></small>
                </div>
                {!showDaysPlayedInsteadOfStreak && <StreakSaveBalanceBtn balance={streakSaveBalance} />}
                <DailyReminderBtn
                  dailyReminderEmail={dailyReminderEmail}
                  dailyReminderEmailUrl={dailyReminderEmailUrl}
                />
                <StreakToggleBtn
                  baseLanguageCode={this.props.baseLanguageCode}
                  languagePairingUrl={languagePairingUrl}
                  onChange={(showDaysPlayedInsteadOfStreak) => this.setState({ showDaysPlayedInsteadOfStreak })}
                  showDaysPlayedInsteadOfStreak={showDaysPlayedInsteadOfStreak}
                  targetLanguageCode={this.props.targetLanguageCode}
                />
              </div>
              {!showDaysPlayedInsteadOfStreak && (
                <div className={`joystix tw-my-2.5 ${currentStreakIncludesToday ? "tw-color-streak-active" : ""}`} data-testid="streak">
                  <span className="tw-text-4xl">{currentStreakDays.toLocaleString()}</span> Day{currentStreakDays === 1 ? "" : "s"}
                </div>
              )}
              {showDaysPlayedInsteadOfStreak && (
                <div className={`joystix tw-my-2.5 ${currentStreakIncludesToday ? "tw-color-streak-active" : ""}`}>
                  <span className="tw-text-4xl">{daysPlayedCount.toLocaleString()}</span> Day{daysPlayedCount === 1 ? "" : "s"}
                </div>
              )}
              {currentStreakIncludesToday && <div>Includes today! <Icon style={{ color: "#27bb4e" }} name="ok" /></div>}
            </div>
          </div>
        </Panel>

        {/* Past 7 Days Chart + Stats */}
        <Panel>
          {this.renderPast7DaysChart()}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
            <FullHistoryBtn
              dailyStatsUrl={dailyStatsUrl}
              user={user}
            />
            <button
              className="btn btn-default btn-xs"
              onClick={() => { window.localStorage.setItem("dashboardStatsExpandedV5", !statsExpanded); this.setState({ statsExpanded: !statsExpanded }); }}
            >
              {statsExpanded ? "Fewer" : "More"} Stats <Icon name={`chevron-${statsExpanded ? "up" : "down"}`} />
            </button>
          </div>
          {statsExpanded && (
            <div className="stats-expanded-detail">
              <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
                <div className="col-sm-4" style={{ display: "flex" }}>
                  <Panel className="stat-panel score" style={{ flex: 1 }}>
                    <div className="text-uppercase" style={{ fontWeight: "bold" }}>Score</div>
                    <div className="joystix value" style={{ fontSize: 28, margin: "8px 0" }}>{score.toLocaleString()}</div>
                    <div>Playing: <strong>{numPlaying.toLocaleString()}</strong></div>
                    <div>Mastered: <strong>{numMastered.toLocaleString()}</strong></div>
                  </Panel>
                </div>
                <div className="col-sm-4" style={{ display: "flex" }}>
                  <Panel style={{ flex: 1 }}>
                    <div className="text-uppercase" style={{ fontWeight: "bold" }}>Level {level}</div>
                    <div className="joystix" style={{ fontSize: 28, margin: "8px 0" }}>{level.toLocaleString()}</div>
                    <div className="progress" style={{ height: 10, margin: "8px 0 4px" }}>
                      <div className="progress-bar progress-bar-success" style={{ width: (((score - currentLevelPoints) / (nextLevelPoints - currentLevelPoints)) * 100) + "%" }}></div>
                    </div>
                    <div>{(nextLevelPoints - score).toLocaleString()} to level {level + 1}</div>
                  </Panel>
                </div>
                <div className="col-sm-4" style={{ display: "flex" }}>
                  <Panel style={{ flex: 1 }}>
                    <div className="text-uppercase" style={{ fontWeight: "bold" }}>Played Today</div>
                    <div className="joystix" style={{ fontSize: 28, margin: "8px 0" }}>{past7DaysNewReview[6].numNew + past7DaysNewReview[6].numReview}</div>
                    <div><strong>{past7DaysNewReview[6].numNew}</strong> New / <strong>{past7DaysNewReview[6].numReview}</strong> Review</div>
                  </Panel>
                </div>
              </div>
              <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
                <div className="col-sm-4" style={{ display: "flex" }}>
                  <Panel attrs={{ "data-testid": "leaderboard-stat" }} style={{ flex: 1 }}>
                    <div className="text-uppercase" style={{ fontWeight: "bold" }}>Leaderboard</div>
                    <div className="joystix" style={{ fontSize: 28, margin: "8px 0" }}>{currentWeekLeaderboardRank ? `#${currentWeekLeaderboardRank}` : "N/A"}</div>
                    <div style={{ marginBottom: 4 }}>This week in points</div>
                    <button className="btn btn-default btn-xs joystix" onClick={() => this.setState({ rankingsModalVisible: true })}>View</button>
                  </Panel>
                </div>
                <div className="col-sm-4" style={{ display: "flex" }}>
                  <Panel attrs={{ "data-testid": "favorites-stat" }} style={{ flex: 1 }}>
                    <div className="text-uppercase" style={{ fontWeight: "bold" }}>Favorites</div>
                    <div className="joystix" data-testid="favorites-count" style={{ fontSize: 28, margin: "8px 0" }}>{numFavorited.toLocaleString()}</div>
                    <button className="btn btn-default joystix btn-xs" disabled={!numFavorited} onClick={() => this.openFavoritesModal("view")} style={{ marginRight: 4 }}>View</button>
                    <button className="btn btn-success-outline joystix btn-xs" disabled={!numFavorited} onClick={() => this.openFavoritesModal("play")}>Play</button>
                  </Panel>
                </div>
                <div className="col-sm-4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <button className="btn btn-default btn-sm more-stats" onClick={() => this.onMoreStatsBtnClick()}>
                    Charts and Graphs
                  </button>
                </div>
              </div>
            </div>
          )}
        </Panel>

        {this.renderExtraData()}

        {!collections.filter((c) => c.dashboardCollection).length && (
          <Panel>
          <div className="tw-flex tw-flex-col tw-items-center tw-my-10">
            <div className="tw-mb-10 tw-text-5xl tw-font-bold tw-text-center">Choose a collection and get in the game!</div>
            <button className="btn btn-success btn-lg joystix" onClick={() => this.setState({ activeTab: "collections" })} style={{ minWidth: 280 }}>Start <Icon name="chevron-right" /></button>
          </div>
          </Panel>
        )}

        {/* Daily Goal */}
        <V5DailyGoalPanel
          activeMobilePanels={-1}
          hoursLeft={dailyGoalHoursLeftToday}
          numPointsToday={numPointsToday}
          pointsPerDay={dailyGoalPointsPerDay}
          updateUrl={dailyGoalUrl}
        />

        {collections.find((c) => c.dashboardCollection) && (
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
              {!(this.isTodaysPlanOn() && collections.filter((c) => c.dashboardCollection).length < 2) && (
                <p className="joystix" style={{ margin: 0 }}>{this.isTodaysPlanOn() ? "My collections" : "In Progress"}</p>
              )}
              {!!collections.filter((c) => c.dashboardCollection).length && (
                <div className="btn-group">
                  <button type="button" className="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown">
                    Sort: {dashboardCollectionSort === "name" ? "A-Z" : "Last Played"} <span className="caret"></span>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-right">
                    <li className={dashboardCollectionSort === "name" ? "active" : ""}><a role="button" onClick={() => { window.localStorage.setItem("dashboardCollectionSort", "name"); this.setState({ dashboardCollectionSort: "name" }); }}>Alphabetical</a></li>
                    <li className={dashboardCollectionSort === "lastPlayed" ? "active" : ""}><a role="button" onClick={() => { window.localStorage.setItem("dashboardCollectionSort", "lastPlayed"); this.setState({ dashboardCollectionSort: "lastPlayed" }); }}>Last Played</a></li>
                  </ul>
                </div>
              )}
            </div>

            {!collections.filter((c) => c.dashboardCollection).length && (
              <Panel>
              <div className="tw-flex tw-flex-col tw-items-center tw-my-10">
                <div className="tw-mb-10 tw-text-5xl tw-font-bold tw-text-center">Choose a collection and get in the game!</div>
                <button className="btn btn-success btn-lg joystix" onClick={() => this.setState({ activeTab: "collections" })} style={{ minWidth: 280 }}>Start <Icon name="chevron-right" /></button>
              </div>
              </Panel>
            )}

            {this.isTodaysPlanOn() && (
              <MyCollections
                collections={collections.filter((c) => c.dashboardCollection)}
                isPro={!!user.isPro}
                onReset={(c) => this.setState({ resetConfirmCollection: c })}
                onUnpin={(c) => this.requestUnpin(c)}
                planStatus={this.state.todaysPlanStatus}
                renderBody={(c) => this.renderDashboardCollectionBody(c)}
                renderProgress={(c) => <CollectionProgressBars collection={c} onShowMasteryHelp={() => this.setState({ masteryHelpCollection: c })} />}
                sortCollections={(list) => this.sortDashboardCollections(list)}
                username={user.username}
              />
            )}

            {!this.isTodaysPlanOn() && this.sortDashboardCollections(collections.filter((c) => c.dashboardCollection)).map((c) => (
              <Panel attrs={{ "data-collection-name": c.name, "data-testid": "collection" }}>
                <div className="tw-flex tw-flex-row tw-mb-10 tw-items-start">
                  <div className="md:tw-flex md:tw-flex-row tw-flex-1 md:tw-items-center md:tw-gap-4">
                    <div className="tw-text-5xl tw-font-bold">{c.name}</div>
                    {this.readableCollectionType(c.type) && (
                      <div>
                        <button
                          className="btn btn-success-outline btn-xs"
                          onClick={() => this.setState({ collectionTypeModal: c.type })}
                        >
                          {this.readableCollectionType(c.type)}
                        </button>
                      </div>
                    )}
                  </div>
                  <DropDownMenu
                    button={
                      <button className="btn btn-default btn-sm collection-menu-toggle" data-toggle="dropdown">
                        <Icon name="option-horizontal" />
                      </button>
                    }
                    lis={
                      <>
                        {c.isEditable && <li><a data-target="#" role="button" onClick={() => this.showAddToCollectionModal(c)}><Icon name="plus" /><span className="tw-ml-5">Add Sentences</span></a></li>}
                        <li><a data-target="#" role="button" onClick={() => this.setState({ managingCollection: c })}><Icon name="list" /><span className="tw-ml-5">Manage Sentences</span></a></li>
                        {/*<li><a data-target="#" role="button" onClick={() => this.setState({ collectionReviewSettingsVisible: c })}><Icon name="cog" /><span className="tw-ml-5">Review Settings</span></a></li>*/}
                        {c.isEditable && <li><a data-target="#" role="button" onClick={() => this.showCollectionEditor(c)}><Icon name="pencil" /><span className="tw-ml-5">Edit Collection</span></a></li>}
                        <li role="separator" className="divider"></li>
                        <li>
                          <a
                            data-target="#"
                            role="button"
                            onClick={() => this.requestUnpin(c)}
                          >
                            <Icon name="pushpin" /><span className="tw-ml-5">Unpin from Dashboard</span>
                          </a>
                        </li>
                      </>
                    }
                    right={true}
                  />
                  
                </div>
                {this.renderDashboardCollectionBody(c)}
              </Panel>
            ))}
          </div>
        )}
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
          <div className="tw-flex-1">
            <button className="btn btn-default btn-md md:tw-mr-5 tw-w-full md:tw-w-auto" onClick={() => this.setState({ activeTab: "collections" })}><Icon name="plus" /> Add Collection</button>
          </div>
          <div className="tw-flex md:tw-hidden tw-flex-col tw-gap-2">
            <button className="btn btn-default btn-block" onClick={() => this.onSearchBtnClick()}><Icon name="search" /> Search Sentences</button>
            <button className="btn btn-default btn-block" onClick={() => this.showAddSentenceToCollectionModal()}><Icon name="plus" /> Add Sentence to Collection</button>
          </div>
          <div className="tw-mt-5 md:tw-mt-0">
            <button className="btn btn-default btn-xs tw-mr-5" onClick={() => this.toggleBackgroundImage()}>
              Background Image {this.state.backgroundImageEnabled ? "On" : "Off"}
            </button>
            <button className="btn btn-default btn-xs tw-mr-5" id="reset-progress-btn" data-toggle="modal" data-target="#reset-progress-modal">
              Reset<span className="tw-hidden md:tw-inline"> Progress</span>
            </button>
            <button className="btn btn-default btn-xs" id="delete-language-pairing-btn" data-toggle="modal" data-target="#delete-language-pairing-modal">
              Delete<span className="tw-hidden md:tw-inline"> Language Pairing</span>
            </button>
          </div>
        </div>
      </>
    );
  }

  render() {
    const {
      baseLanguageFlagIso,
      baseLanguageName,
      blogPostsPath,
      clozeReadingPath,
      // compInputsPath,
      languagePairings,
      monthlyCollectionPollUrl,
      targetLanguageFlagIso,
      targetLanguageName,
      unseenUserNotificationsCount,
      userProfilePath
    } = this.props;

    const {
      activeTab,
      // compInputsUrl,
      discoverMediasUrl,
      gameSettingsUrl,
      loading,
      backgroundImageEnabled,
      user
    } = this.state;

    if(loading) {
      return (
        <div className="tw-mt-10 tw-flex tw-flex-column tw-justify-center tw-flex-1">
          <Loading />
        </div>
      );
    }

    return (
      <div id="dashboard" className="container-fluid tw-flex tw-flex-col tw-flex-1 tw-ml-0">
        {/* HEADER BAR */}
        <div className="tw-flex tw-flex-row tw-items-center tw-py-3 tw-px-4 tw-gap-4" style={{ backgroundColor: "#464646", borderBottom: "3px solid #000", marginLeft: -15, marginRight: -15, paddingLeft: 15, paddingRight: 15 }}>
          {/* Left: Logo */}
          <div className="tw-flex tw-flex-row tw-items-center tw-shrink-0">
            <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M12.7875 23.5429L14.7805 25.5341H21.3061V32.0373L23.2737 34H34.1826V2.05782L32.1197 0H21.2966V4.24881H17.05V6.22102L15.0792 4.25832H12.7843V1.95953L10.8199 0H0V32.0373L1.96755 34H12.7875V23.5429Z" fill="#0A0A0A"/>
              <path d="M22.4466 30.8928H30.9684V1.14795H22.4466V5.39676H18.1873V9.64557H13.928V5.39676H9.66866V1.14795H1.15002V30.8928H9.66866V18.1432H13.928V22.3952H18.1873V18.1432H22.4466V30.8928Z" fill="#5CB85B"/>
            </svg>
            <div className="joystix tw-ml-2 tw-text-white tw-hidden md:tw-inline">Clozemaster</div>
          </div>

          {/* Right: Language dropdown, user dropdown */}
          <div className="tw-flex tw-flex-row tw-items-stretch tw-gap-2 tw-ml-auto">
            <LanguagePairingDropdown
              baseLanguageFlagIso={baseLanguageFlagIso}
              languagePairings={languagePairings}
              targetLanguageFlagIso={targetLanguageFlagIso}
              targetLanguageName={targetLanguageName}
            />

            {/*<button className="btn btn-default tw-hidden md:tw-inline-block more-stats" onClick={() => this.onMoreStatsBtnClick()} title="More stats"><Icon name="stats" /></button>*/}

            <div className="btn-group user-menu">
              <button type="button" className="btn btn-success-outline dropdown-toggle" data-toggle="dropdown" style={{ background: "none", color: "#fff", height: "100%" }}>
                <Icon name="user" /> <span className="caret"></span>
              </button>
              <ul className="dropdown-menu dropdown-menu-right">
                <li>
                  <span style={{ display: "block", padding: "3px 20px" }}>
                    <small>Username:</small>
                    <br />
                    <span className="joystix tw-mr-2">{user.username}</span>
                    <small><a href="/settings">Edit</a></small>
                  </span>
                </li>
                <li role="separator" className="divider"></li>
                {!user.isPro && (
                  <li><a className="joystix" href="/pro"><Icon name="star" /> Clozemaster Pro</a></li>
                )}
                <li><a className="joystix" href="/settings"><Icon name="wrench" /> Account</a></li>
                {this.isTodaysPlanOn() && (
                  <li><a className="joystix" data-testid="review-settings-entry" onClick={() => this.onReviewSettingsBtnClick()} role="button"><Icon name="cog" /> Review Settings</a></li>
                )}
                <li><a className="joystix" href="/notifications"><Icon name="bell" /> Notifications{!!unseenUserNotificationsCount && <span className="badge tw-ml-5">{unseenUserNotificationsCount}</span>}</a></li>
                <li><a className="joystix" href="/activity-feed"><Icon name="list-alt" /> Activity Feed</a></li>
                <li><a className="joystix" href={userProfilePath}><Icon name="user" /> Profile</a></li>
                <li><a className="joystix" href="/players/leaderboard"><Icon name="sort" /> Leaderboard</a></li>
                <li><a className="joystix" href="https://forum.clozemaster.com"><Icon name="comment" /> Forum</a></li>
                <li role="separator" className="divider"></li>
                <li>
                  <span style={{ display: "block", padding: "3px 20px" }}>
                    <DarkModeToggle gameSettingsUrl={gameSettingsUrl} />
                  </span>
                </li>
                {!!monthlyCollectionPollUrl && (
                  <li><a className="joystix" href={monthlyCollectionPollUrl}><Icon name="signal" /> Collection Poll</a></li>
                )}
                <li role="separator" className="divider"></li>
                <li><a className="joystix" href="/logout"><Icon name="log-out" /> Logout</a></li>
              </ul>
            </div>
          </div>
        </div>

        {this.renderQuickPlay()?.mobileBanner}

        {/* MOBILE BOTTOM NAV */}
        <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 md:tw-hidden tw-bg-black tw-flex tw-flex-row" style={{ borderTop: "3px solid #000", zIndex: 1035 }}>
          {[
            ["dashboard", "Dashboard", "home"],
            ["collections", "Collections", "tasks"],
            !user.isPro && ["", "Pro", "star", "/pro"],
            !!clozeReadingPath && ["cloze-reading", "Stories", "book", clozeReadingPath],
            // !!compInputsUrl && ["comp-inputs", "CI", "education", compInputsPath]
          ].filter((a) => a).map((a) => (
            <a
              data-target="#"
              role="button"
              className={`tw-decoration-none tw-block tw-flex-1 tw-py-6 ${activeTab === a[0] ? "tw-bg-success !tw-text-black" : "!tw-text-white "} text-center`}
              href={a[3]}
              key={a[0]}
              onClick={() => this.setState({ activeTab: a[0] })}
            >
              <Icon name={a[2]} />
              <span className="tw-block tw-text-xs">{a[1]}</span>
            </a>
          ))}
          {this.props.quickCapture && (
            <QuickCaptureBtn
              className="tw-flex-1 tw-py-6 tw-bg-transparent tw-border-0 !tw-text-white text-center"
              collectionsUrl={this.state.collectionsUrl}
              demoEntries={this.props.quickCaptureDemoEntries}
              entriesUrl={this.props.quickCaptureEntriesUrl}
              importsUrl={this.props.quickCaptureImportsUrl}
              isPro={this.state.user?.isPro}
              targetLanguageEnglishName={this.props.targetLanguageEnglishName}
              targetLanguageIso={this.props.targetLanguageIso}
              targetLanguageName={this.props.targetLanguageName}
              title="Quick Capture"
            >
              <Icon name="plus" />
              <span className="tw-block tw-text-xs">Capture</span>
            </QuickCaptureBtn>
          )}
        </div>

        {/* SINGLE CENTER COLUMN */}
        <div className="tw-max-w-screen-lg tw-mx-auto tw-w-full tw-px-5 tw-pt-5 tw-pb-20">
          {/* Nav tabs + action buttons (desktop) */}
          <div className="tw-hidden md:tw-flex" style={{ alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <div style={{ display: "flex", gap: 24 }}>
              {[["dashboard", "Dashboard"], ["collections", "Collections"], !!discoverMediasUrl && ["discover", "Discover"], !!clozeReadingPath && ["cloze-reading", "Stories", clozeReadingPath]/*, !!compInputsUrl && ["comp-inputs", "Comp Input"]*/].filter((li) => li).map((li) => (
                <a
                  key={li[0]}
                  href={li[2]}
                  role="button"
                  className={`joystix dashboard-nav-tab ${activeTab === li[0] ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: li[0] })}
                >
                  {li[1]}
                </a>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
              {this.props.quickCapture && (
                <QuickCaptureBtn
                  className="btn btn-default"
                  collectionsUrl={this.state.collectionsUrl}
                  demoEntries={this.props.quickCaptureDemoEntries}
                  entriesUrl={this.props.quickCaptureEntriesUrl}
                  importsUrl={this.props.quickCaptureImportsUrl}
                  isPro={this.state.user?.isPro}
                  targetLanguageEnglishName={this.props.targetLanguageEnglishName}
                  targetLanguageIso={this.props.targetLanguageIso}
                  targetLanguageName={this.props.targetLanguageName}
                />
              )}
              <button className="btn btn-default" onClick={() => this.onSearchBtnClick()} title="Search sentences"><Icon name="search" /></button>
              <button className="btn btn-default" onClick={() => this.showAddSentenceToCollectionModal()} title="Add sentence to collection"><Icon name="plus" /></button>
            </div>
          </div>
          {activeTab === "dashboard" && this.props.blackFridayBanner && <BlackFridayBanner {...this.props.blackFridayBanner} />}
          {this.renderActiveTab()}
        </div>

        {this.renderModals()}
        <DownloadAppBanner
          androidUrl={this.props.androidAppUrl}
          iosUrl={this.props.iosAppUrl}
        />
      </div>
    );
  }
}
